export const chordProgressionGroups = [
  {
    category: "Basic Chords",
    progressions: [
      {
        id: "basic_c_f_g_c",
        name: "Basic I-IV-V-I",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["C3", "E3", "G3"] },
        ],
      },
      {
        id: "basic_c_g_am_f",
        name: "Pop I-V-vi-IV",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["F3", "A3", "C4"] },
        ],
      },
      {
        id: "basic_am_f_c_g",
        name: "Emotional vi-IV-I-V",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["C3", "E3", "G3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "basic_c_am_f_g",
        name: "Classic I-vi-IV-V",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
    ],
  },
  {
    category: "Jazz Chords",
    progressions: [
      {
        id: "jazz_ii_v_i",
        name: "Jazz ii-V-I Turnaround",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "jazz_i_vi_ii_v",
        name: "Jazz I-vi-ii-V",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["A3", "C4", "E4", "G4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "jazz_cmaj9_am9_dm9_g13",
        name: "Smooth Jazz Maj9 Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["A3", "C4", "E4", "G4", "B4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
        ],
      },
      {
        id: "jazz_backdoor",
        name: "Backdoor Cadence Loop",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["F3", "G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3", "G#3"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "jazz_bebop_turnaround",
        name: "Bebop Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] },
        ],
      },
      {
        id: "jazz_coltrane_mini",
        name: "Coltrane Mini Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["D#3", "G3", "A#3", "C#4"] },
          { step: 8, notes: ["G#3", "C4", "D#4", "G4"] },
          { step: 12, notes: ["B3", "D#4", "F#4", "A4"] },
        ],
      },
      {
        id: "jazz_minor_251",
        name: "Minor ii-V-i Turnaround",
        chords: [
          { step: 0, notes: ["D3", "F3", "G#3", "C4"] },
          { step: 4, notes: ["G3", "B3", "D#4", "F4"] },
          { step: 8, notes: ["C3", "D#3", "G3", "B3"] },
          { step: 12, notes: ["F3", "G#3", "C4", "D#4"] },
        ],
      },
      {
        id: "jazz_modal_quartal",
        name: "Modal Quartal",
        chords: [
          { step: 0, notes: ["C3", "F3", "A#3"] },
          { step: 4, notes: ["D3", "G3", "C4"] },
          { step: 8, notes: ["D#3", "G#3", "C#4"] },
          { step: 12, notes: ["F3", "A#3", "D#4"] },
        ],
      },
      {
        id: "jazz_gospel_soul",
        name: "Gospel Soul",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["E3", "G#3", "B3", "D4", "F#4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4", "B4"] },
          { step: 12, notes: ["F3", "A3", "C4", "E4", "G4"] },
        ],
      },
    ],
  },
  {
    category: "Advanced Jazz Standards",
    progressions: [
      {
        id: "advanced_jazz_01",
        name: "Autumn Leaves",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4", "B4"] }, // Am9
          { step: 4, notes: ["D3", "F#3", "A3", "C4", "E4"] }, // D9
          { step: 8, notes: ["G3", "B3", "D4", "F4", "A4"] }, // G13
          { step: 12, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 15, notes: ["F3", "A3", "C4", "E4", "G4"] }, // Fmaj9
        ],
      },

      {
        id: "advanced_jazz_02",
        name: "Blue Bossa",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3", "D4"] },
          { step: 4, notes: ["F3", "A3", "C4", "D#4", "G4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
          { step: 15, notes: ["C3", "D#3", "G3", "A#3", "D4"] },
        ],
      },

      {
        id: "advanced_jazz_03",
        name: "Misty",
        chords: [
          { step: 0, notes: ["E3", "G#3", "B3", "D#4", "F#4"] },
          { step: 4, notes: ["A3", "C#4", "E4", "G4", "B4"] },
          { step: 8, notes: ["D3", "F#3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
          { step: 15, notes: ["C3", "E3", "G3", "B3", "D4"] },
        ],
      },

      {
        id: "advanced_jazz_04",
        name: "All The Things You Are",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4", "G4"] },
          { step: 3, notes: ["A#2", "D3", "F3", "A3", "C4"] },
          { step: 6, notes: ["E3", "G#3", "B3", "D4", "F#4"] },
          { step: 9, notes: ["A3", "C#4", "E4", "G4", "B4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4", "E4"] },
        ],
      },

      {
        id: "advanced_jazz_05",
        name: "Take Five",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["G3", "A#3", "D4", "F4", "A4"] },
          { step: 8, notes: ["C3", "E3", "G3", "A#3", "D4"] },
          { step: 12, notes: ["A3", "C4", "E4", "G4", "B4"] },
        ],
      },

      {
        id: "advanced_jazz_06",
        name: "So What",
        chords: [
          { step: 0, notes: ["D3", "G3", "C4", "F4", "A4"] },
          { step: 4, notes: ["D#3", "G#3", "C#4", "F#4", "A#4"] },
          { step: 8, notes: ["D3", "G3", "C4", "F4", "A4"] },
          { step: 12, notes: ["A3", "C4", "E4", "G4", "B4"] },
        ],
      },

      {
        id: "advanced_jazz_07",
        name: "Spain",
        chords: [
          { step: 0, notes: ["B2", "D#3", "F#3", "A3", "C#4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4", "A4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 12, notes: ["F3", "A3", "C4", "E4", "G4"] },
          { step: 15, notes: ["A3", "C#4", "E4", "G4", "B4"] },
        ],
      },

      {
        id: "advanced_jazz_08",
        name: "Giant Steps",
        chords: [
          { step: 0, notes: ["B2", "D#3", "F#3", "A#3", "C#4"] },
          { step: 3, notes: ["G3", "B3", "D4", "F#4", "A4"] },
          { step: 6, notes: ["D#3", "G3", "A#3", "D4", "F4"] },
          { step: 9, notes: ["B3", "D#4", "F#4", "A4", "C#5"] },
          { step: 12, notes: ["F#3", "A#3", "C#4", "E#4", "G#4"] },
        ],
      },

      {
        id: "advanced_jazz_09",
        name: "Confirmation",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 3, notes: ["A3", "C#4", "E4", "G4", "B4"] },
          { step: 6, notes: ["D3", "F#3", "A3", "C4", "E4"] },
          { step: 9, notes: ["G3", "B3", "D4", "F4", "A4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4", "F#4"] },
        ],
      },

      {
        id: "advanced_jazz_10",
        name: "Cherokee",
        chords: [
          { step: 0, notes: ["Bb2", "D3", "F3", "A3", "C4"] },
          { step: 3, notes: ["Eb3", "G3", "Bb3", "D4", "F4"] },
          { step: 6, notes: ["Ab2", "C3", "Eb3", "G3", "Bb3"] },
          { step: 9, notes: ["Db3", "F3", "Ab3", "C4", "Eb4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
        ],
      },

      {
        id: "advanced_jazz_11",
        name: "Round Midnight",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "B3", "D4"] },
          { step: 4, notes: ["F#3", "A3", "C4", "E4", "G4"] },
          { step: 8, notes: ["B2", "D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4", "F4"] },
        ],
      },

      {
        id: "advanced_jazz_12",
        name: "Solar",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3", "D4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4", "G4"] },
          { step: 8, notes: ["Bb2", "D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["Eb3", "G3", "Bb3", "D4", "F4"] },
        ],
      },

      {
        id: "advanced_jazz_13",
        name: "Maiden Voyage",
        chords: [
          { step: 0, notes: ["D3", "A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["F3", "C4", "Eb4", "G4", "Bb4"] },
          { step: 8, notes: ["Eb3", "Bb3", "Db4", "F4", "Ab4"] },
          { step: 12, notes: ["G3", "D4", "F4", "A4", "C5"] },
        ],
      },

      {
        id: "advanced_jazz_14",
        name: "Footprints",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "Bb3", "D4"] },
          { step: 4, notes: ["F3", "Ab3", "C4", "Eb4", "G4"] },
          { step: 8, notes: ["Bb2", "Db3", "F3", "Ab3", "C4"] },
          { step: 12, notes: ["Eb3", "G3", "Bb3", "D4", "F4"] },
        ],
      },

      {
        id: "advanced_jazz_15",
        name: "Birdland",
        chords: [
          { step: 0, notes: ["E3", "G#3", "B3", "D#4", "F#4"] },
          { step: 4, notes: ["C3", "E3", "G3", "Bb3", "D4"] },
          { step: 8, notes: ["A3", "C#4", "E4", "G4", "B4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4", "E4"] },
        ],
      },

      {
        id: "advanced_jazz_16",
        name: "Donna Lee",
        chords: [
          { step: 0, notes: ["Ab2", "C3", "Eb3", "G3", "Bb3"] },
          { step: 3, notes: ["Db3", "F3", "Ab3", "C4", "Eb4"] },
          { step: 6, notes: ["Gb2", "Bb2", "Db3", "F3", "Ab3"] },
          { step: 9, notes: ["B2", "D#3", "F#3", "A3", "C#4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D#4", "F#4"] },
        ],
      },

      {
        id: "advanced_jazz_17",
        name: "There Will Never Be Another You",
        chords: [
          { step: 0, notes: ["Eb3", "G3", "Bb3", "D4", "F4"] },
          { step: 4, notes: ["Ab3", "C4", "Eb4", "G4", "Bb4"] },
          { step: 8, notes: ["D3", "F#3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
        ],
      },

      {
        id: "advanced_jazz_18",
        name: "Stella By Starlight",
        chords: [
          { step: 0, notes: ["Bb2", "D3", "F3", "A3", "C4"] },
          { step: 4, notes: ["Eb3", "G3", "Bb3", "D4", "F4"] },
          { step: 8, notes: ["Ab2", "C3", "Eb3", "G3", "Bb3"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4", "E4"] },
          { step: 15, notes: ["G3", "B3", "D4", "F4", "A4"] },
        ],
      },

      {
        id: "advanced_jazz_19",
        name: "Body And Soul",
        chords: [
          { step: 0, notes: ["Db3", "F3", "Ab3", "C4", "Eb4"] },
          { step: 4, notes: ["Gb3", "Bb3", "Db4", "F4", "Ab4"] },
          { step: 8, notes: ["B2", "D#3", "F#3", "A3", "C#4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4", "F#4"] },
        ],
      },

      {
        id: "advanced_jazz_20",
        name: "Night In Tunisia",
        chords: [
          { step: 0, notes: ["Dm3", "F3", "A3", "C4", "E4"] },
          { step: 3, notes: ["Eb3", "G3", "Bb3", "Db4", "F4"] },
          { step: 6, notes: ["F3", "A3", "C4", "Eb4", "G4"] },
          { step: 9, notes: ["E3", "G#3", "B3", "D4", "F4"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4", "B4"] },
        ],
      },
    ],
  },
  {
    category: "Level 1 - Easy Jazz",
    goal: "Learn ii-V-I, Turnarounds, Swing Standards",
    progressions: [
      {
        id: "easy_jazz_01",
        name: "Basic ii-V-I",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 5, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 10, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "easy_jazz_02",
        name: "Classic Jazz Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["A2", "C3", "E3", "G3"] }, // Am7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "easy_jazz_03",
        name: "Descending Circle Progression",
        chords: [
          { step: 0, notes: ["E3", "G3", "B3", "D4"] }, // Em7
          { step: 4, notes: ["A2", "C3", "E3", "G3"] }, // Am7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "easy_jazz_04",
        name: "Minor Turnaround to Major",
        chords: [
          { step: 0, notes: ["A2", "C3", "E3", "G3"] }, // Am7
          { step: 4, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 8, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 12, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "easy_jazz_05",
        name: "Major Walk-Up ii-V-I",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 8, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 12, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "easy_jazz_06",
        name: "Subdominant ii-V-I",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] }, // Fmaj7
          { step: 4, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 8, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 12, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "easy_jazz_07",
        name: "Secondary Dominant Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "easy_jazz_08",
        name: "Extended Circle Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 3, notes: ["E3", "G3", "B3", "D4"] }, // Em7
          { step: 6, notes: ["A2", "C3", "E3", "G3"] }, // Am7
          { step: 9, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "easy_jazz_09",
        name: "Extended ii-V-I",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 5, notes: ["G2", "B2", "D3", "F3", "E4"] }, // G13
          { step: 10, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
        ],
      },

      {
        id: "easy_jazz_10",
        name: "Extended Jazz Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 4, notes: ["A2", "C3", "E3", "G3", "B3"] }, // Am9
          { step: 8, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 12, notes: ["G2", "B2", "D3", "F3", "E4"] }, // G13
        ],
      },
    ],
    standards: [
      "Fly Me To The Moon",
      "Blue Moon",
      "Autumn Leaves",
      "Satin Doll",
    ],
    skills: ["ii-V-I", "Basic voice leading", "Swing rhythm"],
  },

  {
    category: "Level 2 - Medium Jazz",
    goal: "Secondary Dominants and Diminished Passing Chords",
    progressions: [
      {
        id: "medium_jazz_01",
        name: "Secondary Dominant ii-V",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "medium_jazz_02",
        name: "Chromatic Diminished Passing",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["C#3", "E3", "G3", "A#3"] }, // C#dim7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "medium_jazz_03",
        name: "Chain of Secondary Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 3, notes: ["E3", "G#3", "B3", "D4"] }, // E7
          { step: 6, notes: ["A2", "C3", "E3", "G3"] }, // Am7
          { step: 9, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "medium_jazz_04",
        name: "Subdominant Diminished Passing",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] }, // Fmaj7
          { step: 4, notes: ["F#3", "A3", "C4", "D#4"] }, // F#dim7
          { step: 8, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 12, notes: ["A2", "C#3", "E3", "G3"] }, // A7
        ],
      },

      {
        id: "medium_jazz_05",
        name: "Dominant Expansion",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 3, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 6, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 9, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "medium_jazz_06",
        name: "Backcycling ii-V-I",
        chords: [
          { step: 0, notes: ["E3", "G3", "B3", "D4"] }, // Em7
          { step: 3, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 6, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 9, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 12, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "medium_jazz_07",
        name: "Backdoor Dominant Movement",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 3, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 6, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 9, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "medium_jazz_08",
        name: "Cycle of ii-V Progressions",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 3, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 6, notes: ["E3", "G3", "B3", "D4"] }, // Em7
          { step: 9, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 12, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 15, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "medium_jazz_09",
        name: "Extended Secondary Dominant",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 4, notes: ["A2", "C#3", "E3", "G3", "F#4"] }, // A13
          { step: 8, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 12, notes: ["G2", "B2", "D3", "F3", "E4"] }, // G13
        ],
      },

      {
        id: "medium_jazz_10",
        name: "Altered Dominant Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 3, notes: ["E3", "G#3", "B3", "D4", "G4"] }, // E7#9
          { step: 6, notes: ["A2", "C3", "E3", "G3"] }, // Am7
          { step: 9, notes: ["D3", "F#3", "A3", "C4", "B4"] }, // D13
          { step: 12, notes: ["G2", "B2", "D3", "F3", "E4"] }, // G13
        ],
      },
    ],
    standards: [
      "Blue Bossa",
      "Take The A Train",
      "There Will Never Be Another You",
    ],
    skills: [
      "Secondary dominants",
      "Passing diminished chords",
      "Extended chords",
    ],
  },
  {
    category: "Level 3 - Hard Jazz",
    goal: "Modal Interchange and Tritone Substitutions",
    progressions: [
      {
        id: "hard_jazz_01",
        name: "Tritone Substitute ii-V-I",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 5, notes: ["C#3", "F3", "G#3", "B3"] }, // Db7
          { step: 10, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "hard_jazz_02",
        name: "Minor Backdoor Cadence",
        chords: [
          { step: 0, notes: ["F3", "G#3", "C4", "D#4"] }, // Fm7
          { step: 5, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 10, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "hard_jazz_03",
        name: "Borrowed Major Backdoor",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["G#2", "C3", "D#3", "G3"] }, // Abmaj7
          { step: 8, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 12, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "hard_jazz_04",
        name: "Descending Tritone Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["D#3", "G3", "A#3", "C#4"] }, // Eb7
          { step: 8, notes: ["G#2", "C3", "D#3", "G3"] }, // Abmaj7
          { step: 12, notes: ["C#3", "F3", "G#3", "B3"] }, // Db7
        ],
      },

      {
        id: "hard_jazz_05",
        name: "Altered Turnaround",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 4, notes: ["G3", "B3", "D4", "F4"] }, // G7
          { step: 8, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 12, notes: ["A2", "C#3", "E3", "G3", "A#3"] }, // A7b9
        ],
      },

      {
        id: "hard_jazz_06",
        name: "Chromatic Extended Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 4, notes: ["A#2", "D3", "F3", "G#3", "G4"] }, // Bb13
          { step: 8, notes: ["D#3", "G3", "A#3", "D4", "F4"] }, // Ebmaj9
          { step: 12, notes: ["G#2", "C3", "D#3", "F#3", "F4"] }, // Ab13
        ],
      },

      {
        id: "hard_jazz_07",
        name: "Major to Minor Backdoor",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["F3", "G#3", "C4", "D#4"] }, // Fm7
          { step: 8, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 12, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "hard_jazz_08",
        name: "Major Third Modal Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 4, notes: ["D#3", "G3", "A#3", "D4"] }, // Ebmaj7
          { step: 8, notes: ["G#2", "C3", "D#3", "G3"] }, // Abmaj7
          { step: 12, notes: ["C#3", "F3", "G#3", "C4"] }, // Dbmaj7
        ],
      },

      {
        id: "hard_jazz_09",
        name: "Extended Backcycling",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 3, notes: ["B2", "D#3", "F#3", "A3"] }, // B7
          { step: 6, notes: ["E3", "G3", "B3", "D4"] }, // Em7
          { step: 9, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 12, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 15, notes: ["G3", "B3", "D4", "F4"] }, // G7
        ],
      },

      {
        id: "hard_jazz_10",
        name: "Minor Major Resolution",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "B3"] }, // CmMaj7
          { step: 4, notes: ["D3", "F3", "G#3", "C4"] }, // Dm7b5
          { step: 8, notes: ["G2", "B2", "D3", "F3", "G#3"] }, // G7b9
          { step: 12, notes: ["C3", "D#3", "G3", "B3"] }, // CmMaj7
        ],
      },
    ],
    skills: [
      "Modal interchange",
      "Tritone substitutions",
      "Backdoor cadences",
      "Altered dominants",
      "Advanced voice leading",
    ],
  },
  {
    category: "Level 4 - Very Hard Jazz",
    goal: "Bebop, Fusion and Advanced Reharmonization",
    progressions: [
      {
        id: "very_hard_jazz_01",
        name: "Fusion Extended Turnaround",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 3,
            notes: ["E3", "G#3", "B3", "D4", "G4"],
          }, // E7#9
          {
            step: 6,
            notes: ["A2", "C3", "E3", "G3", "B3", "D4"],
          }, // Am11
          {
            step: 9,
            notes: ["D3", "F#3", "A3", "C4", "B4"],
          }, // D13
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "E4"],
          }, // G13
          {
            step: 15,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
        ],
      },

      {
        id: "very_hard_jazz_02",
        name: "Diminished Passing Reharm",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 4,
            notes: ["C#3", "E3", "G3", "A#3"],
          }, // C#dim7
          {
            step: 8,
            notes: ["D3", "F3", "A3", "C4", "E4"],
          }, // Dm9
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "E4"],
          }, // G13
        ],
      },

      {
        id: "very_hard_jazz_03",
        name: "Chromatic Major Reharm",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 3,
            notes: ["D#3", "G3", "A#3", "C#4"],
          }, // Eb7
          {
            step: 6,
            notes: ["G#2", "C3", "D#3", "G3"],
          }, // Abmaj7
          {
            step: 9,
            notes: ["B2", "D#3", "F#3", "A3"],
          }, // B7
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D#4"],
          }, // Emaj7
        ],
      },

      {
        id: "very_hard_jazz_04",
        name: "Extended Backcycling",
        chords: [
          {
            step: 0,
            notes: ["E3", "G3", "B3", "D4", "F#4"],
          }, // Em9
          {
            step: 4,
            notes: ["A2", "C#3", "E3", "G3", "F#4"],
          }, // A13
          {
            step: 8,
            notes: ["D3", "F3", "A3", "C4", "E4"],
          }, // Dm9
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "E4"],
          }, // G13
          {
            step: 15,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
        ],
      },

      {
        id: "very_hard_jazz_05",
        name: "Altered Dominant Backcycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 4,
            notes: ["B2", "D#3", "F#3", "A3", "C4"],
          }, // B7alt
          {
            step: 8,
            notes: ["E3", "G3", "B3", "D4", "F#4"],
          }, // Em9
          {
            step: 12,
            notes: ["A2", "C#3", "E3", "G3", "F#4"],
          }, // A13
        ],
      },

      {
        id: "very_hard_jazz_06",
        name: "Descending Fusion Dominants",
        chords: [
          {
            step: 0,
            notes: ["F3", "A3", "C4", "E4", "G4"],
          }, // Fmaj9
          {
            step: 4,
            notes: ["A#2", "D3", "F3", "G#3", "G4"],
          }, // Bb13
          {
            step: 8,
            notes: ["D#3", "G3", "A#3", "D4", "F4"],
          }, // Ebmaj9
          {
            step: 12,
            notes: ["G#2", "C3", "D#3", "F#3", "F4"],
          }, // Ab13
        ],
      },

      {
        id: "very_hard_jazz_07",
        name: "Bass-Line Reharmonization",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 4,
            notes: ["B2", "D3", "F3", "G3"],
          }, // G7/B
          {
            step: 8,
            notes: ["A#2", "D3", "F3", "G#3", "G4"],
          }, // Bb13
          {
            step: 12,
            notes: ["A2", "C#3", "E3", "G3"],
          }, // A7
        ],
      },

      {
        id: "very_hard_jazz_08",
        name: "Distant Key Reharmonization",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 4,
            notes: ["C#3", "F3", "G#3", "B3", "A#4"],
          }, // Db13
          {
            step: 8,
            notes: ["F#2", "A#2", "C#3", "F3", "G#3"],
          }, // Gbmaj9
          {
            step: 12,
            notes: ["B2", "D#3", "F#3", "A3", "G#4"],
          }, // B13
        ],
      },

      {
        id: "very_hard_jazz_09",
        name: "Minor Fusion Resolution",
        chords: [
          {
            step: 0,
            notes: ["C3", "D#3", "G3", "B3", "D4"],
          }, // CmMaj9
          {
            step: 4,
            notes: ["G#2", "C3", "D#3", "G3", "A#3"],
          }, // Abmaj9
          {
            step: 8,
            notes: ["D3", "F3", "G#3", "C4"],
          }, // Dm7b5
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "G#3", "A#3"],
          }, // G7alt
        ],
      },

      {
        id: "very_hard_jazz_10",
        name: "Upper Extension Turnaround",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4", "A4"],
          }, // Cmaj13
          {
            step: 4,
            notes: ["A2", "C#3", "E3", "G3", "F#4"],
          }, // A13
          {
            step: 8,
            notes: ["D3", "F3", "A3", "C4", "E4", "G4"],
          }, // Dm11
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "E4"],
          }, // G13
        ],
      },
    ],
    artists: ["Pat Metheny", "Herbie Hancock", "Chick Corea", "Weather Report"],
    skills: [
      "Fusion harmony",
      "Upper extensions",
      "Complex reharmonization",
      "Altered dominants",
      "Advanced chord substitution",
    ],
  },

  {
    category: "Level 5 - God Mode Jazz",
    goal: "Coltrane Changes, Modern Jazz and Multi-Tonic Harmony",
    progressions: [
      {
        id: "god_mode_jazz_01",
        name: "Coltrane-Style Multi-Tonic Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 3,
            notes: ["D#3", "G3", "A#3", "C#4"],
          }, // Eb7
          {
            step: 6,
            notes: ["G#2", "C3", "D#3", "G3"],
          }, // Abmaj7
          {
            step: 9,
            notes: ["B2", "D#3", "F#3", "A3"],
          }, // B7
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D#4"],
          }, // Emaj7
          {
            step: 14,
            notes: ["G2", "B2", "D3", "F3"],
          }, // G7
          {
            step: 15,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
        ],
      },

      {
        id: "god_mode_jazz_02",
        name: "Giant Steps Tonal Cycle",
        chords: [
          {
            step: 0,
            notes: ["B2", "D#3", "F#3", "A#3"],
          }, // Bmaj7
          {
            step: 3,
            notes: ["D3", "F#3", "A3", "C4"],
          }, // D7
          {
            step: 6,
            notes: ["G2", "B2", "D3", "F#3"],
          }, // Gmaj7
          {
            step: 9,
            notes: ["A#2", "D3", "F3", "G#3"],
          }, // Bb7
          {
            step: 12,
            notes: ["D#3", "G3", "A#3", "D4"],
          }, // Ebmaj7
          {
            step: 14,
            notes: ["F#2", "A#2", "C#3", "E3"],
          }, // F#7
          {
            step: 15,
            notes: ["B2", "D#3", "F#3", "A#3"],
          }, // Bmaj7
        ],
      },

      {
        id: "god_mode_jazz_03",
        name: "Modern Extended Multi-Tonic Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4", "A4"],
          }, // Cmaj13
          {
            step: 2,
            notes: ["E3", "G#3", "B3", "D4", "G4"],
          }, // E7#9
          {
            step: 4,
            notes: ["G#2", "C3", "D#3", "G3", "A#3"],
          }, // Abmaj9
          {
            step: 6,
            notes: ["C#3", "F3", "G#3", "B3", "A#4"],
          }, // Db13
          {
            step: 8,
            notes: ["F3", "A3", "C4", "E4", "G4"],
          }, // Fmaj9
          {
            step: 10,
            notes: ["B2", "D#3", "F#3", "A3", "G#4"],
          }, // B13
          {
            step: 12,
            notes: ["E3", "G3", "B3", "D4", "F#4", "A4"],
          }, // Em11
          {
            step: 13,
            notes: ["A2", "C#3", "E3", "G3", "F#4"],
          }, // A13
          {
            step: 14,
            notes: ["D3", "F3", "A3", "C4", "E4", "G4"],
          }, // Dm11
          {
            step: 15,
            notes: ["G2", "B2", "D3", "F3", "E4"],
          }, // G13
        ],
      },

      {
        id: "god_mode_jazz_04",
        name: "Symmetrical Dominant Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 4,
            notes: ["D#3", "G3", "A#3", "C#4"],
          }, // Eb7
          {
            step: 8,
            notes: ["F#2", "A#2", "C#3", "E3"],
          }, // Gb7
          {
            step: 12,
            notes: ["A2", "C#3", "E3", "G3"],
          }, // A7
          {
            step: 15,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
        ],
      },

      {
        id: "god_mode_jazz_05",
        name: "Descending Major Third Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 3,
            notes: ["F#2", "A#2", "C#3", "E3"],
          }, // F#7
          {
            step: 6,
            notes: ["B2", "D#3", "F#3", "A#3", "C#4"],
          }, // Bmaj9
          {
            step: 9,
            notes: ["D3", "F#3", "A3", "C4"],
          }, // D7
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F#3", "A3"],
          }, // Gmaj9
          {
            step: 14,
            notes: ["A#2", "D3", "F3", "G#3"],
          }, // Bb7
          {
            step: 15,
            notes: ["D#3", "G3", "A#3", "D4", "F4"],
          }, // Ebmaj9
        ],
      },

      {
        id: "god_mode_jazz_06",
        name: "Major Third Mediant Shifts",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 5,
            notes: ["E3", "G#3", "B3", "D#4", "F#4"],
          }, // Emaj9
          {
            step: 10,
            notes: ["G#2", "C3", "D#3", "G3", "A#3"],
          }, // Abmaj9
          {
            step: 15,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
        ],
      },

      {
        id: "god_mode_jazz_07",
        name: "Chromatic Major Planing",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 3,
            notes: ["C#3", "F3", "G#3", "C4"],
          }, // Dbmaj7
          {
            step: 6,
            notes: ["D3", "F#3", "A3", "C#4"],
          }, // Dmaj7
          {
            step: 9,
            notes: ["D#3", "G3", "A#3", "D4"],
          }, // Ebmaj7
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D#4"],
          }, // Emaj7
        ],
      },

      {
        id: "god_mode_jazz_08",
        name: "Descending Dominant Matrix",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4", "A4"],
          }, // Cmaj13
          {
            step: 2,
            notes: ["A#2", "D3", "F3", "G#3", "G4"],
          }, // Bb13
          {
            step: 4,
            notes: ["G#2", "C3", "D#3", "F#3", "F4"],
          }, // Ab13
          {
            step: 6,
            notes: ["C#3", "F3", "G#3", "B3", "A#4"],
          }, // Db13
          {
            step: 8,
            notes: ["F#2", "A#2", "C#3", "E3", "D#4"],
          }, // Gb13
          {
            step: 10,
            notes: ["B2", "D#3", "F#3", "A3", "G#4"],
          }, // B13
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D4", "C#5"],
          }, // E13
          {
            step: 13,
            notes: ["A2", "C#3", "E3", "G3", "F#4"],
          }, // A13
          {
            step: 14,
            notes: ["D3", "F#3", "A3", "C4", "B4"],
          }, // D13
          {
            step: 15,
            notes: ["G2", "B2", "D3", "F3", "E4"],
          }, // G13
        ],
      },

      {
        id: "god_mode_jazz_09",
        name: "Minor Third Major Chord Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3"],
          }, // Cmaj7
          {
            step: 4,
            notes: ["D#3", "G3", "A#3", "D4"],
          }, // Ebmaj7
          {
            step: 8,
            notes: ["F#2", "A#2", "C#3", "F3"],
          }, // F#maj7
          {
            step: 12,
            notes: ["A2", "C#3", "E3", "G#3"],
          }, // Amaj7
        ],
      },

      {
        id: "god_mode_jazz_10",
        name: "Whole-Key Major Thirteen Ascension",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4", "A4"],
          }, // Cmaj13
          {
            step: 2,
            notes: ["D3", "F#3", "A3", "C#4", "E4", "B4"],
          }, // Dmaj13
          {
            step: 4,
            notes: ["E3", "G#3", "B3", "D#4", "F#4", "C#5"],
          }, // Emaj13
          {
            step: 6,
            notes: ["F#2", "A#2", "C#3", "F3", "G#3", "D#4"],
          }, // F#maj13
          {
            step: 8,
            notes: ["G2", "B2", "D3", "F#3", "A3", "E4"],
          }, // Gmaj13
          {
            step: 10,
            notes: ["A2", "C#3", "E3", "G#3", "B3", "F#4"],
          }, // Amaj13
          {
            step: 12,
            notes: ["B2", "D#3", "F#3", "A#3", "C#4", "G#4"],
          }, // Bmaj13
        ],
      }, // ============================================================
      // GOD MODE JAZZ — ADDITIONAL 30 PROGRESSIONS
      // IDs: god_mode_jazz_11 → god_mode_jazz_40
      // ============================================================

      {
        id: "god_mode_jazz_11",
        name: "Coltrane Minor Multi-Tonic Matrix",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "B3", "D4"] }, // Cm(maj9)
          { step: 3, notes: ["F#2", "A#2", "C#3", "E3", "G#3"] }, // F#13
          { step: 6, notes: ["B2", "D3", "F#3", "A#3", "C#4"] }, // Bm(maj9)
          { step: 9, notes: ["D3", "F#3", "A3", "C4", "E4"] }, // D9
          { step: 12, notes: ["G2", "A#2", "D3", "F#3", "A3"] }, // Gm(maj9)
          { step: 14, notes: ["A#2", "D3", "F3", "G#3", "C4"] }, // Bb13
          { step: 15, notes: ["D#3", "F#3", "A#3", "D4", "F4"] }, // Ebm(maj9)
        ],
      },

      {
        id: "god_mode_jazz_12",
        name: "Tritone Substitution Labyrinth",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 2, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 4, notes: ["C#3", "F3", "G#3", "B3", "D4"] }, // Db9#11
          { step: 6, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 8, notes: ["A2", "C3", "E3", "G3", "B3"] }, // Am9
          { step: 10, notes: ["G#2", "C3", "D#3", "F#3", "A#3"] }, // Ab13
          { step: 12, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 14, notes: ["C#3", "F3", "G#3", "B3"] }, // Db7
          { step: 15, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "god_mode_jazz_13",
        name: "Diminished Dominant Axis",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "C#4"] }, // C7b9
          { step: 4, notes: ["D#3", "G3", "A#3", "C#4", "E4"] }, // Eb7b9
          { step: 8, notes: ["F#2", "A#2", "C#3", "E3", "G3"] }, // F#7b9
          { step: 12, notes: ["A2", "C#3", "E3", "G3", "A#3"] }, // A7b9
          { step: 15, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
        ],
      },

      {
        id: "god_mode_jazz_14",
        name: "Altered Dominant Chain",
        chords: [
          { step: 0, notes: ["E3", "G#3", "A#3", "D4", "F4"] }, // E7alt
          { step: 2, notes: ["A2", "C#3", "D#3", "G3", "A#3"] }, // A7alt
          { step: 4, notes: ["D3", "F#3", "G3", "C4", "D#4"] }, // D7alt
          { step: 6, notes: ["G2", "B2", "C3", "F3", "G#3"] }, // G7alt
          { step: 8, notes: ["C3", "E3", "F3", "A#3", "C#4"] }, // C7alt
          { step: 10, notes: ["F2", "A2", "B2", "D#3", "F#3"] }, // F7alt
          { step: 12, notes: ["A#2", "D3", "D#3", "G#3", "B3"] }, // Bb7alt
          { step: 14, notes: ["D#3", "G3", "G#3", "C#4", "E4"] }, // Eb7alt
          { step: 15, notes: ["G#2", "C3", "D#3", "G3", "A#3"] }, // Abmaj9
        ],
      },

      {
        id: "god_mode_jazz_15",
        name: "Chromatic ii-V Side-Slip",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 2, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 4, notes: ["D#3", "F#3", "A#3", "C#4", "F4"] }, // Ebm9
          { step: 6, notes: ["G#2", "C3", "D#3", "F#3", "A#3"] }, // Ab13
          { step: 8, notes: ["E3", "G3", "B3", "D4", "F#4"] }, // Em9
          { step: 10, notes: ["A2", "C#3", "E3", "G3", "B3"] }, // A9
          { step: 12, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 14, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 15, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
        ],
      },

      {
        id: "god_mode_jazz_16",
        name: "Major Seventh Constant-Structure Descent",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 3, notes: ["B2", "D#3", "F#3", "A#3", "C#4"] }, // Bmaj9
          { step: 6, notes: ["A#2", "D3", "F3", "A3", "C4"] }, // Bbmaj9
          { step: 9, notes: ["A2", "C#3", "E3", "G#3", "B3"] }, // Amaj9
          { step: 12, notes: ["G#2", "C3", "D#3", "G3", "A#3"] }, // Abmaj9
          { step: 15, notes: ["G2", "B2", "D3", "F#3", "A3"] }, // Gmaj9
        ],
      },

      {
        id: "god_mode_jazz_17",
        name: "Minor-Major Seventh Galaxy",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "B3", "D4"] }, // Cm(maj9)
          { step: 4, notes: ["E3", "G3", "B3", "D#4", "F#4"] }, // Em(maj9)
          { step: 8, notes: ["G#2", "B2", "D#3", "G3", "A#3"] }, // Abm(maj9)
          { step: 12, notes: ["B2", "D3", "F#3", "A#3", "C#4"] }, // Bm(maj9)
          { step: 15, notes: ["C3", "D#3", "G3", "B3", "D4"] }, // Cm(maj9)
        ],
      },

      {
        id: "god_mode_jazz_18",
        name: "Lydian Chromatic Ascension",
        chords: [
          { step: 0, notes: ["C3", "E3", "F#3", "B3", "D4"] }, // Cmaj9#11
          { step: 3, notes: ["D3", "F#3", "G#3", "C#4", "E4"] }, // Dmaj9#11
          { step: 6, notes: ["E3", "G#3", "A#3", "D#4", "F#4"] }, // Emaj9#11
          { step: 9, notes: ["F#2", "A#2", "C3", "F3", "G#3"] }, // F#maj9#11
          { step: 12, notes: ["G#2", "C3", "D3", "G3", "A#3"] }, // Abmaj9#11
          { step: 15, notes: ["A#2", "D3", "E3", "A3", "C4"] }, // Bbmaj9#11
        ],
      },

      {
        id: "god_mode_jazz_19",
        name: "Backdoor Dominant Hypercycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 3, notes: ["F3", "G#3", "C4", "D#4", "G4"] }, // Fm9
          { step: 6, notes: ["A#2", "D3", "F3", "G#3", "C4"] }, // Bb13
          { step: 9, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 11, notes: ["G#2", "B2", "D#3", "F#3", "A#3"] }, // Abm9
          { step: 13, notes: ["C#3", "F3", "G#3", "B3", "D#4"] }, // Db13
          { step: 15, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "god_mode_jazz_20",
        name: "Tritone ii-V Mirror System",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 2, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 4, notes: ["G#2", "B2", "D#3", "F#3", "A#3"] }, // Abm9
          { step: 6, notes: ["C#3", "F3", "G#3", "B3", "D#4"] }, // Db9
          { step: 8, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 11, notes: ["F#2", "A2", "C#3", "E3", "G#3"] }, // F#m9
          { step: 13, notes: ["B2", "D#3", "F#3", "A3", "C#4"] }, // B9
          { step: 15, notes: ["E3", "G3", "B3", "D4", "F#4"] }, // Em9
        ],
      },

      {
        id: "god_mode_jazz_21",
        name: "Descending Whole-Tone Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "A#3", "D4", "F#4"] }, // C9#11
          { step: 3, notes: ["A#2", "D3", "G#3", "C4", "E4"] }, // Bb9#11
          { step: 6, notes: ["G#2", "C3", "F#3", "A#3", "D4"] }, // Ab9#11
          { step: 9, notes: ["F#2", "A#2", "E3", "G#3", "C#4"] }, // Gb9#11
          { step: 12, notes: ["E3", "G#3", "D4", "F#4", "A#4"] }, // E9#11
          { step: 15, notes: ["D3", "F#3", "C4", "E4", "G#4"] }, // D9#11
        ],
      },

      {
        id: "god_mode_jazz_22",
        name: "Neo-Soul Jazz Mediant Matrix",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4", "A4"] }, // Cmaj13
          { step: 4, notes: ["E3", "G#3", "B3", "D#4", "F#4"] }, // Emaj9
          { step: 8, notes: ["G#2", "C3", "D#3", "G3", "A#3"] }, // Abmaj9
          { step: 12, notes: ["F3", "A3", "C4", "E4", "G4"] }, // Fmaj9
          { step: 15, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
        ],
      },

      {
        id: "god_mode_jazz_23",
        name: "Chromatic Minor ii-V Descent",
        chords: [
          { step: 0, notes: ["E3", "G3", "A#3", "D4"] }, // Em7b5
          { step: 2, notes: ["A2", "C#3", "E3", "G3", "A#3"] }, // A7b9
          { step: 4, notes: ["D#3", "F#3", "A3", "C#4"] }, // Ebm7b5
          { step: 6, notes: ["G#2", "C3", "D#3", "F#3", "A3"] }, // Ab7b9
          { step: 8, notes: ["D3", "F3", "G#3", "C4"] }, // Dm7b5
          { step: 10, notes: ["G2", "B2", "D3", "F3", "G#3"] }, // G7b9
          { step: 12, notes: ["C#3", "E3", "G3", "B3"] }, // C#m7b5
          { step: 14, notes: ["F#2", "A#2", "C#3", "E3", "G3"] }, // F#7b9
          { step: 15, notes: ["B2", "D3", "F#3", "A3", "C#4"] }, // Bm9
        ],
      },

      {
        id: "god_mode_jazz_24",
        name: "Augmented Major Tonal Triangle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G#3", "B3", "D4"] }, // Cmaj9#5
          { step: 5, notes: ["E3", "G#3", "C4", "D#4", "F#4"] }, // Emaj9#5
          { step: 10, notes: ["G#2", "C3", "E3", "G3", "A#3"] }, // Abmaj9#5
          { step: 15, notes: ["C3", "E3", "G#3", "B3", "D4"] }, // Cmaj9#5
        ],
      },

      {
        id: "god_mode_jazz_25",
        name: "Dominant Minor-Third Axis",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          { step: 4, notes: ["D#3", "G3", "A#3", "C#4", "F4"] }, // Eb9
          { step: 8, notes: ["F#2", "A#2", "C#3", "E3", "G#3"] }, // F#9
          { step: 12, notes: ["A2", "C#3", "E3", "G3", "B3"] }, // A9
          { step: 15, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
        ],
      },

      {
        id: "god_mode_jazz_26",
        name: "Giant Steps Reverse Engine",
        chords: [
          { step: 0, notes: ["B2", "D#3", "F#3", "A#3"] }, // Bmaj7
          { step: 3, notes: ["F#2", "A#2", "C#3", "E3"] }, // F#7
          { step: 6, notes: ["D#3", "G3", "A#3", "D4"] }, // Ebmaj7
          { step: 9, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 12, notes: ["G2", "B2", "D3", "F#3"] }, // Gmaj7
          { step: 14, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 15, notes: ["B2", "D#3", "F#3", "A#3"] }, // Bmaj7
        ],
      },

      {
        id: "god_mode_jazz_27",
        name: "Upper-Structure Altered Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "A#3", "C#4", "D#4", "G#4"] }, // C7alt
          { step: 4, notes: ["F3", "A3", "D#4", "F#4", "G#4", "C#5"] }, // F7alt
          { step: 8, notes: ["A#2", "D3", "G#3", "B3", "C#4", "F#4"] }, // Bb7alt
          { step: 12, notes: ["D#3", "G3", "C#4", "E4", "F#4", "B4"] }, // Eb7alt
          { step: 15, notes: ["G#2", "C3", "D#3", "G3", "A#3"] }, // Abmaj9
        ],
      },

      {
        id: "god_mode_jazz_28",
        name: "Quartal Modal Interchange",
        chords: [
          { step: 0, notes: ["C3", "F3", "A#3", "D#4", "G#4"] }, // C quartal
          { step: 4, notes: ["D3", "G3", "C4", "F4", "A#4"] }, // D quartal
          { step: 8, notes: ["D#3", "G#3", "C#4", "F#4", "A#4"] }, // Eb quartal
          { step: 12, notes: ["F3", "A#3", "D#4", "G#4", "C5"] }, // F quartal
          { step: 15, notes: ["C3", "F3", "A#3", "D#4", "G#4"] }, // C quartal
        ],
      },

      {
        id: "god_mode_jazz_29",
        name: "Chromatic Dominant Side-Step",
        chords: [
          { step: 0, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 2, notes: ["G#2", "C3", "D#3", "F#3", "A#3"] }, // Ab13
          { step: 4, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 6, notes: ["F#2", "A#2", "C#3", "E3", "G#3"] }, // F#9
          { step: 8, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 10, notes: ["C#3", "F3", "G#3", "B3", "D#4"] }, // Db9
          { step: 12, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
        ],
      },

      {
        id: "god_mode_jazz_30",
        name: "Double Tritone Resolution",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 3, notes: ["C#3", "F3", "G#3", "B3", "D4"] }, // Db9
          { step: 6, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 9, notes: ["A2", "C3", "E3", "G3", "B3"] }, // Am9
          { step: 12, notes: ["G#2", "C3", "D#3", "F#3", "A#3"] }, // Ab13
          { step: 15, notes: ["G2", "B2", "D3", "F#3", "A3"] }, // G9
        ],
      },

      {
        id: "god_mode_jazz_31",
        name: "Major Third Dominant Teleportation",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          { step: 4, notes: ["E3", "G#3", "B3", "D4", "F#4"] }, // E9
          { step: 8, notes: ["G#2", "C3", "D#3", "F#3", "A#3"] }, // Ab13
          { step: 12, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          { step: 15, notes: ["F3", "A3", "C4", "E4", "G4"] }, // Fmaj9
        ],
      },

      {
        id: "god_mode_jazz_32",
        name: "Minor Third Tonal Centers",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 4, notes: ["D#3", "G3", "A#3", "D4", "F4"] }, // Ebmaj9
          { step: 8, notes: ["F#2", "A#2", "C#3", "F3", "G#3"] }, // F#maj9
          { step: 12, notes: ["A2", "C#3", "E3", "G#3", "B3"] }, // Amaj9
          { step: 15, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
        ],
      },

      {
        id: "god_mode_jazz_33",
        name: "Descending Minor-Major Planing",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "B3"] }, // Cm(maj7)
          { step: 3, notes: ["B2", "D3", "F#3", "A#3"] }, // Bm(maj7)
          { step: 6, notes: ["A#2", "C#3", "F3", "A3"] }, // Bbm(maj7)
          { step: 9, notes: ["A2", "C3", "E3", "G#3"] }, // Am(maj7)
          { step: 12, notes: ["G#2", "B2", "D#3", "G3"] }, // Abm(maj7)
          { step: 15, notes: ["G2", "A#2", "D3", "F#3"] }, // Gm(maj7)
        ],
      },

      {
        id: "god_mode_jazz_34",
        name: "Lydian Dominant Matrix",
        chords: [
          { step: 0, notes: ["C3", "E3", "F#3", "A#3", "D4"] }, // C13#11
          { step: 4, notes: ["D#3", "G3", "A3", "C#4", "F4"] }, // Eb13#11
          { step: 8, notes: ["F#2", "A#2", "C3", "E3", "G#3"] }, // F#13#11
          { step: 12, notes: ["A2", "C#3", "D#3", "G3", "B3"] }, // A13#11
          { step: 15, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
        ],
      },

      {
        id: "god_mode_jazz_35",
        name: "Bebop Chromatic Turnaround Extreme",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 2, notes: ["A2", "C#3", "E3", "G3", "B3"] }, // A9
          { step: 4, notes: ["G#2", "C3", "D#3", "F#3", "A#3"] }, // Ab13
          { step: 6, notes: ["G2", "B2", "D3", "F3", "A3"] }, // G9
          { step: 8, notes: ["F#2", "A#2", "C#3", "E3", "G#3"] }, // F#9
          { step: 10, notes: ["F2", "A2", "C3", "D#3", "G3"] }, // F9
          { step: 12, notes: ["E3", "G#3", "B3", "D4", "F#4"] }, // E9
          { step: 14, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 15, notes: ["G2", "B2", "D3", "F3"] }, // G7
        ],
      },

      {
        id: "god_mode_jazz_36",
        name: "Modal Coltrane Hybrid",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 3, notes: ["F#2", "A#2", "C#3", "E3"] }, // F#7
          { step: 6, notes: ["B2", "D#3", "F#3", "A#3", "C#4"] }, // Bmaj9
          { step: 9, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 12, notes: ["G2", "B2", "D3", "F#3", "A3"] }, // Gmaj9
          { step: 14, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 15, notes: ["D#3", "G3", "A#3", "D4", "F4"] }, // Ebmaj9
        ],
      },

      {
        id: "god_mode_jazz_37",
        name: "Chromatic Mediant Film-Jazz Matrix",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
          { step: 3, notes: ["E3", "G#3", "B3", "D#4", "F#4"] }, // Emaj9
          { step: 6, notes: ["D#3", "G3", "A#3", "D4", "F4"] }, // Ebmaj9
          { step: 9, notes: ["G2", "B2", "D3", "F#3", "A3"] }, // Gmaj9
          { step: 12, notes: ["F#2", "A#2", "C#3", "F3", "G#3"] }, // F#maj9
          { step: 15, notes: ["C3", "E3", "G3", "B3", "D4"] }, // Cmaj9
        ],
      },

      {
        id: "god_mode_jazz_38",
        name: "Diminished Passing Chord Maze",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
          { step: 2, notes: ["C#3", "E3", "G3", "A#3"] }, // C#dim7
          { step: 4, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 6, notes: ["D#3", "F#3", "A3", "C4"] }, // D#dim7
          { step: 8, notes: ["E3", "G3", "B3", "D4"] }, // Em7
          { step: 10, notes: ["F3", "G#3", "B3", "D4"] }, // Fdim7
          { step: 12, notes: ["F#2", "A2", "C3", "D#3"] }, // F#dim7
          { step: 14, notes: ["G2", "B2", "D3", "F3"] }, // G7
          { step: 15, notes: ["C3", "E3", "G3", "B3"] }, // Cmaj7
        ],
      },

      {
        id: "god_mode_jazz_39",
        name: "Superimposed Major Triad Harmony",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "D4", "F#4", "A4"] }, // C + D major
          { step: 4, notes: ["D#3", "G3", "A#3", "F4", "A4", "C5"] }, // Eb + F major
          { step: 8, notes: ["F#2", "A#2", "C#3", "G#3", "B3", "D4"] }, // F# + G
          { step: 12, notes: ["A2", "C#3", "E3", "B3", "D#4", "F#4"] }, // A + B
          { step: 15, notes: ["C3", "E3", "G3", "D4", "F#4", "A4"] }, // C + D
        ],
      },

      {
        id: "god_mode_jazz_40",
        name: "Final Boss Multi-Tonic Reharmonization",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4", "F#4"] }, // Cmaj9#11
          { step: 2, notes: ["D#3", "G3", "A#3", "C#4", "F4"] }, // Eb13
          { step: 4, notes: ["G#2", "C3", "D#3", "G3", "A#3"] }, // Abmaj9
          { step: 6, notes: ["B2", "D#3", "F#3", "A3", "C4"] }, // B9
          { step: 8, notes: ["E3", "G#3", "B3", "D#4", "F#4"] }, // Emaj9
          { step: 10, notes: ["G2", "B2", "D3", "F3", "G#3"] }, // G7b9
          { step: 12, notes: ["C3", "D#3", "G3", "A#3", "D4"] }, // Cm9
          { step: 13, notes: ["C#3", "F3", "G#3", "B3", "D#4"] }, // Db9#11
          { step: 14, notes: ["F#2", "A#2", "C#3", "E3", "G3"] }, // F#7alt
          { step: 15, notes: ["B2", "D#3", "F#3", "A#3", "C#4"] }, // Bmaj9
        ],
      },
    ],
    songs: ["Giant Steps", "Moment's Notice", "26-2", "Countdown"],
    skills: [
      "Symmetrical harmony",
      "Third-cycle modulation",
      "Multi-tonic systems",
      "Advanced voice leading",
      "Chromatic planing",
      "Modern jazz reharmonization",
    ],
  },

  {
    category: "Blues Chords",
    progressions: [
      {
        id: "blues_basic_12_bar_short",
        name: "Basic Blues I-IV-V Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "A3", "C4", "D#4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] },
        ],
      },
      {
        id: "blues_quick_change",
        name: "Quick Change Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 2, notes: ["F3", "A3", "C4", "D#4"] },
          { step: 4, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 8, notes: ["F3", "A3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
          { step: 14, notes: ["D3", "F#3", "A3", "C4"] },
        ],
      },
      {
        id: "blues_turnaround",
        name: "Blues Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 4, notes: ["A3", "C#4", "E4", "G4"] },
          { step: 8, notes: ["D3", "F#3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "blues_jazz_blues",
        name: "Jazz Blues Mini Form",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 2, notes: ["F3", "A3", "C4", "D#4"] },
          { step: 4, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 6, notes: ["G3", "A#3", "D4", "F4"] },
          { step: 8, notes: ["F3", "A3", "C4", "D#4"] },
          { step: 10, notes: ["F#3", "A3", "C4", "D#4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] },
          { step: 14, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
    ],
  },
  {
    category: "Level 2 - Medium Blues",
    goal: "Secondary Dominants, Passing Diminished Chords and Jazz-Blues Movement",
    progressions: [
      {
        id: "medium_blues_01",
        name: "Extended Dominant Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 3, notes: ["F3", "A3", "C4", "D#4"] }, // F7
          { step: 6, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 9, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 15, notes: ["G2", "B2", "D3", "F3"] }, // G7
        ],
      },

      {
        id: "medium_blues_02",
        name: "Jazz Blues with Diminished Passing",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 2, notes: ["F3", "A3", "C4", "D#4"] }, // F7
          { step: 4, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 5, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 6, notes: ["F3", "A3", "C4", "D#4"] }, // F7
          { step: 7, notes: ["F#3", "A3", "C4", "D#4"] }, // F#dim7
          { step: 8, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 10, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 12, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 13, notes: ["G2", "B2", "D3", "F3"] }, // G7
          { step: 14, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 15, notes: ["G2", "B2", "D3", "F3"] }, // G7
        ],
      },

      {
        id: "medium_blues_03",
        name: "Mixolydian Backdoor Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 5, notes: ["A#2", "D3", "F3", "G#3"] }, // Bb7
          { step: 10, notes: ["F3", "A3", "C4", "D#4"] }, // F7
          { step: 15, notes: ["C3", "E3", "G3", "A#3"] }, // C7
        ],
      },

      {
        id: "medium_blues_04",
        name: "Chromatic Dominant Resolution",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 5, notes: ["G#2", "C3", "D#3", "F#3"] }, // Ab7
          { step: 10, notes: ["G2", "B2", "D3", "F3"] }, // G7
          { step: 15, notes: ["C3", "E3", "G3", "A#3"] }, // C7
        ],
      },

      {
        id: "medium_blues_05",
        name: "Cycle of Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 4, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 8, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 12, notes: ["G2", "B2", "D3", "F3"] }, // G7
        ],
      },

      {
        id: "medium_blues_06",
        name: "Descending Chromatic Dominants",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 4, notes: ["D#3", "G3", "A#3", "C#4"] }, // Eb7
          { step: 8, notes: ["D3", "F#3", "A3", "C4"] }, // D7
          { step: 12, notes: ["C#3", "F3", "G#3", "B3"] }, // Db7
        ],
      },

      {
        id: "medium_blues_07",
        name: "Diminished ii-V Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 4, notes: ["C#3", "E3", "G3", "A#3"] }, // C#dim7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G2", "B2", "D3", "F3"] }, // G7
        ],
      },

      {
        id: "medium_blues_08",
        name: "Subdominant Diminished Passing",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "D#4"] }, // F7
          { step: 5, notes: ["F#3", "A3", "C4", "D#4"] }, // F#dim7
          { step: 10, notes: ["C3", "E3", "G3", "A#3"] }, // C7
        ],
      },

      {
        id: "medium_blues_09",
        name: "Minor ii-V into Subdominant",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 4, notes: ["G2", "A#2", "D3", "F3"] }, // Gm7
          { step: 8, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 12, notes: ["F3", "A3", "C4", "D#4"] }, // F7
        ],
      },

      {
        id: "medium_blues_10",
        name: "Jazz Blues Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] }, // C7
          { step: 4, notes: ["A2", "C#3", "E3", "G3"] }, // A7
          { step: 8, notes: ["D3", "F3", "A3", "C4"] }, // Dm7
          { step: 12, notes: ["G2", "B2", "D3", "F3"] }, // G7
        ],
      },
    ],
    artists: ["Stevie Ray Vaughan", "Eric Clapton"],
    skills: [
      "Secondary dominants",
      "Passing diminished chords",
      "Jazz-blues turnarounds",
      "Chromatic dominant movement",
      "Basic blues reharmonization",
    ],
  },

  {
    category: "Level 3 - Hard Blues",
    goal: "Extended Dominants, Altered Chords and Advanced Jazz-Blues Harmony",
    progressions: [
      {
        id: "hard_blues_01",
        name: "Ninth Chord Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          { step: 6, notes: ["F3", "A3", "C4", "D#4", "G4"] }, // F9
          { step: 12, notes: ["G2", "B2", "D3", "F3", "E4"] }, // G13
        ],
      },

      {
        id: "hard_blues_02",
        name: "Thirteenth Chord Blues",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 6,
            notes: ["F3", "A3", "C4", "D#4", "G4", "D5"],
          }, // F13
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "hard_blues_03",
        name: "Hendrix Altered Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D#4"] }, // C7#9
          { step: 6, notes: ["F3", "A3", "C4", "D#4", "G#4"] }, // F7#9
          { step: 12, notes: ["G2", "B2", "D3", "F3", "A#3"] }, // G7#9
        ],
      },

      {
        id: "hard_blues_04",
        name: "Diminished Jazz-Blues Turnaround",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          { step: 4, notes: ["D#3", "F#3", "A3", "C4"] }, // Ebdim7
          { step: 8, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          { step: 12, notes: ["G2", "B2", "D3", "F3", "E4"] }, // G13
        ],
      },

      {
        id: "hard_blues_05",
        name: "Extended Dominant Turnaround",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          { step: 8, notes: ["D3", "F#3", "A3", "C4", "E4"] }, // D9
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "hard_blues_06",
        name: "Backdoor Extended Blues",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          {
            step: 5,
            notes: ["A#2", "D3", "F3", "G#3", "C4", "G4"],
          }, // Bb13
          { step: 10, notes: ["F3", "A3", "C4", "D#4", "G4"] }, // F9
        ],
      },

      {
        id: "hard_blues_07",
        name: "Dominant Extension Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["F3", "A3", "C4", "D#4", "G4", "D5"],
          }, // F13
          {
            step: 8,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 12,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
        ],
      },

      {
        id: "hard_blues_08",
        name: "Extended ii-V-I Blues",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] }, // Dm9
          {
            step: 5,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
          {
            step: 10,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
        ],
      },

      {
        id: "hard_blues_09",
        name: "Diminished Tonic Reharm",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3", "D4"] }, // C9
          { step: 5, notes: ["F#3", "A3", "C4", "D#4"] }, // F#dim7
          {
            step: 10,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
        ],
      },

      {
        id: "hard_blues_10",
        name: "Altered Dominant Blues Cadence",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "F#3", "A#3", "C#4", "D#4"],
          }, // C7alt
          {
            step: 6,
            notes: ["F3", "A3", "C4", "D#4", "G4", "D5"],
          }, // F13
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },
    ],
    skills: [
      "Dominant ninth chords",
      "Dominant thirteenth chords",
      "Altered dominant harmony",
      "Diminished passing movement",
      "Jazz-blues reharmonization",
      "Advanced blues voice leading",
    ],
  },
  {
    category: "Level 4 - Very Hard Blues",
    goal: "Fusion Blues, Altered Dominants and Complex Reharmonization",
    progressions: [
      {
        id: "very_hard_blues_01",
        name: "Extended Blues Turnaround",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 8,
            notes: ["D3", "F3", "A3", "C4", "E4"],
          }, // Dm9
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "very_hard_blues_02",
        name: "Descending Backdoor Dominants",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4"],
          }, // C9
          {
            step: 4,
            notes: ["A#2", "D3", "F3", "G#3", "C4", "G4"],
          }, // Bb13
          {
            step: 8,
            notes: ["D#3", "G3", "A#3", "C#4", "F4"],
          }, // Eb9
          {
            step: 12,
            notes: ["G#2", "C3", "D#3", "F#3", "A#3", "F4"],
          }, // Ab13
        ],
      },

      {
        id: "very_hard_blues_03",
        name: "Altered Dominant Blues Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 3,
            notes: ["E3", "G#3", "B3", "D4", "G4"],
          }, // E7#9
          {
            step: 6,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 9,
            notes: ["D3", "F#3", "A3", "C4", "E4", "B4"],
          }, // D13
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "very_hard_blues_04",
        name: "Major-Minor Blues Reharm",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 4,
            notes: ["C3", "E3", "G3", "A#3"],
          }, // C7
          {
            step: 8,
            notes: ["F3", "A3", "C4", "D#4", "G4", "D5"],
          }, // F13
          {
            step: 12,
            notes: ["F3", "G#3", "C4", "D#4", "G4"],
          }, // Fm9
        ],
      },

      {
        id: "very_hard_blues_05",
        name: "Chromatic Dominant Neighbors",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["C#3", "F3", "G#3", "B3", "D#4", "A#4"],
          }, // Db13
          {
            step: 8,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 12,
            notes: ["B2", "D#3", "F#3", "A3", "C#4", "G#4"],
          }, // B13
        ],
      },

      {
        id: "very_hard_blues_06",
        name: "Altered Secondary Dominant Turnaround",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["A2", "C#3", "G3", "A#3", "D#4"],
          }, // A7alt
          {
            step: 8,
            notes: ["D3", "F3", "A3", "C4", "E4", "G4"],
          }, // Dm11
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "very_hard_blues_07",
        name: "Chromatic Ninth Descent",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4"],
          }, // C9
          {
            step: 4,
            notes: ["D#3", "G3", "A#3", "C#4", "F4"],
          }, // Eb9
          {
            step: 8,
            notes: ["D3", "F#3", "A3", "C4", "E4"],
          }, // D9
          {
            step: 12,
            notes: ["C#3", "F3", "G#3", "B3", "D#4"],
          }, // Db9
        ],
      },

      {
        id: "very_hard_blues_08",
        name: "Descending Extended Dominants",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["G#2", "C3", "D#3", "F#3", "A#3", "F4"],
          }, // Ab13
          {
            step: 8,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
          {
            step: 12,
            notes: ["F3", "A3", "C4", "D#4", "G4", "D5"],
          }, // F13
        ],
      },

      {
        id: "very_hard_blues_09",
        name: "Major Jazz-Blues Turnaround",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 4,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 8,
            notes: ["D3", "F3", "A3", "C4", "E4"],
          }, // Dm9
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "very_hard_blues_10",
        name: "Complete Dominant Backcycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 3,
            notes: ["E3", "G#3", "B3", "D4", "F#4", "C#5"],
          }, // E13
          {
            step: 6,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 9,
            notes: ["D3", "F#3", "A3", "C4", "E4", "B4"],
          }, // D13
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },
    ],
    artists: ["Joe Bonamassa", "Scott Henderson"],
    skills: [
      "Fusion blues harmony",
      "Altered secondary dominants",
      "Chromatic dominant movement",
      "Major-minor reharmonization",
      "Upper chord extensions",
      "Advanced blues voice leading",
    ],
  },

  {
    category: "Level 5 - God Mode Blues Jazz",
    goal: "Modern Blues-Jazz, Symmetrical Harmony and Multi-Tonic Dominant Systems",
    progressions: [
      {
        id: "god_mode_blues_01",
        name: "Extended Dominant Backcycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 3,
            notes: ["E3", "G#3", "B3", "D4", "G4"],
          }, // E7#9
          {
            step: 6,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 9,
            notes: ["D3", "F#3", "A3", "C4", "E4", "B4"],
          }, // D13
          {
            step: 12,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
          {
            step: 15,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
        ],
      },

      {
        id: "god_mode_blues_02",
        name: "Descending Multi-Tonic Reharm",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 3,
            notes: ["D#3", "G3", "A#3", "C#4", "A4"],
          }, // Eb13
          {
            step: 6,
            notes: ["G#2", "C3", "D#3", "G3", "A#3"],
          }, // Abmaj9
          {
            step: 9,
            notes: ["C#3", "F3", "G#3", "B3", "D#4", "A#4"],
          }, // Db13
          {
            step: 12,
            notes: ["F#2", "A#2", "C#3", "F3", "G#3"],
          }, // Gbmaj9
          {
            step: 15,
            notes: ["B2", "D#3", "F#3", "A3", "C#4", "G#4"],
          }, // B13
        ],
      },

      {
        id: "god_mode_blues_03",
        name: "Dominant Matrix Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 2,
            notes: ["A#2", "D3", "F3", "G#3", "C4", "G4"],
          }, // Bb13
          {
            step: 4,
            notes: ["G#2", "C3", "D#3", "F#3", "A#3", "F4"],
          }, // Ab13
          {
            step: 6,
            notes: ["C#3", "F3", "G#3", "B3", "D#4", "A#4"],
          }, // Db13
          {
            step: 8,
            notes: ["F#2", "A#2", "C#3", "E3", "G#3", "D#4"],
          }, // Gb13
          {
            step: 10,
            notes: ["B2", "D#3", "F#3", "A3", "C#4", "G#4"],
          }, // B13
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D4", "F#4", "C#5"],
          }, // E13
          {
            step: 13,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 14,
            notes: ["D3", "F#3", "A3", "C4", "E4", "B4"],
          }, // D13
          {
            step: 15,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "god_mode_blues_04",
        name: "Modern Major-Third Reharm",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 3,
            notes: ["E3", "G#3", "B3", "D4", "G4"],
          }, // E7#9
          {
            step: 6,
            notes: ["G#2", "C3", "D#3", "G3", "A#3"],
          }, // Abmaj9
          {
            step: 9,
            notes: ["C#3", "F3", "G#3", "B3", "D#4", "A#4"],
          }, // Db13
          {
            step: 12,
            notes: ["F3", "A3", "C4", "E4", "G4"],
          }, // Fmaj9
          {
            step: 15,
            notes: ["B2", "D#3", "F#3", "A3", "C#4", "G#4"],
          }, // B13
        ],
      },

      {
        id: "god_mode_blues_05",
        name: "Chromatic Thirteenth Planing",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 3,
            notes: ["C#3", "F3", "G#3", "B3", "D#4", "A#4"],
          }, // C#13
          {
            step: 6,
            notes: ["D3", "F#3", "A3", "C4", "E4", "B4"],
          }, // D13
          {
            step: 9,
            notes: ["D#3", "G3", "A#3", "C#4", "F4", "C5"],
          }, // Eb13
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D4", "F#4", "C#5"],
          }, // E13
        ],
      },

      {
        id: "god_mode_blues_06",
        name: "Descending Minor-Third Dominants",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 3,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 6,
            notes: ["F#2", "A#2", "C#3", "E3", "G#3", "D#4"],
          }, // F#13
          {
            step: 9,
            notes: ["D3", "F#3", "A3", "C4", "E4", "B4"],
          }, // D13
          {
            step: 12,
            notes: ["A#2", "D3", "F3", "G#3", "C4", "G4"],
          }, // Bb13
          {
            step: 15,
            notes: ["G2", "B2", "D3", "F3", "A3", "E4"],
          }, // G13
        ],
      },

      {
        id: "god_mode_blues_07",
        name: "Chromatic Major Thirteen Planing",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4", "A4"],
          }, // Cmaj13
          {
            step: 3,
            notes: ["C#3", "F3", "G#3", "C4", "D#4", "A#4"],
          }, // Dbmaj13
          {
            step: 6,
            notes: ["D3", "F#3", "A3", "C#4", "E4", "B4"],
          }, // Dmaj13
          {
            step: 9,
            notes: ["D#3", "G3", "A#3", "D4", "F4", "C5"],
          }, // Ebmaj13
          {
            step: 12,
            notes: ["E3", "G#3", "B3", "D#4", "F#4", "C#5"],
          }, // Emaj13
        ],
      },

      {
        id: "god_mode_blues_08",
        name: "Symmetrical Minor-Third Dominant Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 4,
            notes: ["D#3", "G3", "A#3", "C#4", "F4", "C5"],
          }, // Eb13
          {
            step: 8,
            notes: ["F#2", "A#2", "C#3", "E3", "G#3", "D#4"],
          }, // Gb13
          {
            step: 12,
            notes: ["A2", "C#3", "E3", "G3", "B3", "F#4"],
          }, // A13
          {
            step: 15,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
        ],
      },

      {
        id: "god_mode_blues_09",
        name: "Augmented Major-Triad Cycle",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
          {
            step: 5,
            notes: ["G#2", "C3", "D#3", "G3", "A#3"],
          }, // Abmaj9
          {
            step: 10,
            notes: ["E3", "G#3", "B3", "D#4", "F#4"],
          }, // Emaj9
          {
            step: 15,
            notes: ["C3", "E3", "G3", "B3", "D4"],
          }, // Cmaj9
        ],
      },

      {
        id: "god_mode_blues_10",
        name: "Cycle of Descending Fourth Dominants",
        chords: [
          {
            step: 0,
            notes: ["C3", "E3", "G3", "A#3", "D4", "A4"],
          }, // C13
          {
            step: 2,
            notes: ["F3", "A3", "C4", "D#4", "G4", "D5"],
          }, // F13
          {
            step: 4,
            notes: ["A#2", "D3", "F3", "G#3", "C4", "G4"],
          }, // Bb13
          {
            step: 6,
            notes: ["D#3", "G3", "A#3", "C#4", "F4", "C5"],
          }, // Eb13
          {
            step: 8,
            notes: ["G#2", "C3", "D#3", "F#3", "A#3", "F4"],
          }, // Ab13
          {
            step: 10,
            notes: ["C#3", "F3", "G#3", "B3", "D#4", "A#4"],
          }, // Db13
          {
            step: 12,
            notes: ["F#2", "A#2", "C#3", "E3", "G#3", "D#4"],
          }, // Gb13
        ],
      },
    ],
    skills: [
      "Symmetrical dominant harmony",
      "Minor-third dominant cycles",
      "Multi-tonic blues systems",
      "Chromatic chord planing",
      "Extended dominant matrices",
      "Advanced altered harmony",
      "Modern jazz-blues voice leading",
    ],
  },
  {
    category: "Carnatic Inspired",
    progressions: [
      {
        id: "carnatic_kalyani_01",
        name: "Kalyani Grand Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["D3", "F#3", "A3", "C#4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F#4"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "carnatic_kalyani_02",
        name: "Kalyani Cinematic",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C#4", "E4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "carnatic_kalyani_03",
        name: "Kalyani Divine Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["F#3", "A3", "C#4", "E4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F#4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C#4"] },
        ],
      },
      {
        id: "carnatic_mohanam_01",
        name: "Mohanam Uplifting Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["D3", "F#3", "A3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C#4", "E4"] },
        ],
      },
      {
        id: "carnatic_mohanam_02",
        name: "Mohanam Festival",
        chords: [
          { step: 0, notes: ["C3", "G3", "C4"] },
          { step: 4, notes: ["D3", "A3", "D4"] },
          { step: 8, notes: ["E3", "G3", "B3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "carnatic_mohanam_03",
        name: "Mohanam Folk Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["A3", "C#4", "E4"] },
        ],
      },
      {
        id: "carnatic_keeravani_01",
        name: "Keeravani Emotional Cycle",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "A#3", "D4"] },
          { step: 12, notes: ["E3", "G#3", "B3"] },
        ],
      },
      {
        id: "carnatic_keeravani_02",
        name: "Keeravani Dark",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["C3", "E3", "G3"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["E3", "G#3", "B3"] },
        ],
      },
      {
        id: "carnatic_keeravani_03",
        name: "Keeravani Suspense",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["D3", "F3", "A3", "C4"] },
          { step: 8, notes: ["F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4"] },
        ],
      },
      {
        id: "carnatic_charukesi_01",
        name: "Charukesi Pathos",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["D#3", "G3", "A#3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "carnatic_charukesi_02",
        name: "Charukesi Cinema",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "G#3", "C4"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "carnatic_abheri_01",
        name: "Abheri Soul",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["D#3", "G3", "A#3"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
      {
        id: "carnatic_abheri_02",
        name: "Abheri Melody Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3", "G#3"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
      {
        id: "carnatic_hamsadhwani_01",
        name: "Hamsadhwani Bright Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["D3", "F#3", "A3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C#4", "E4"] },
        ],
      },
      {
        id: "carnatic_hamsadhwani_02",
        name: "Hamsadhwani Prayer Cycle",
        chords: [
          { step: 0, notes: ["C3", "G3", "C4"] },
          { step: 4, notes: ["E3", "G3", "B3"] },
          { step: 8, notes: ["D3", "G3", "B3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "carnatic_shankarabharanam_01",
        name: "Shankarabharanam Classic Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["D3", "F#3", "A3"] },
        ],
      },
      {
        id: "carnatic_shankarabharanam_02",
        name: "Shankarabharanam Royal",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["A3", "C4", "E4", "G4"] },
          { step: 8, notes: ["F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "carnatic_kharaharapriya_01",
        name: "Kharaharapriya Warm Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "carnatic_kharaharapriya_02",
        name: "Kharaharapriya Folk Soul",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["D3", "F3", "A3", "C4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["A#2", "D3", "F3"] },
        ],
      },
      {
        id: "carnatic_hindolam_01",
        name: "Hindolam Mystic Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D#3", "G3"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
      {
        id: "carnatic_hindolam_02",
        name: "Hindolam Dark Temple Cycle",
        chords: [
          { step: 0, notes: ["C3", "G3", "A#3"] },
          { step: 4, notes: ["D#3", "G3", "A#3"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["A#2", "D#3", "G3"] },
        ],
      },
      {
        id: "carnatic_natabhairavi_01",
        name: "Natabhairavi Minor Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "carnatic_natabhairavi_02",
        name: "Natabhairavi Sad Film",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "G#3", "C4"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "A#3", "D4", "F4"] },
        ],
      },
      {
        id: "carnatic_natabhairavi_03",
        name: "Natabhairavi Epic Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
    ],
  },
  {
    category: "Hindustani Inspired",
    progressions: [
      {
        id: "yaman_01",
        name: "Yaman Evening Cycle",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["D3", "F#3", "A3", "C#4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F#4"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "yaman_02",
        name: "Yaman Romantic",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C#4", "E4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "yaman_03",
        name: "Yaman Mehfil",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["F#3", "A3", "C#4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "bhairavi_01",
        name: "Bhairavi Morning",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["C#3", "F3", "G#3"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "bhairavi_02",
        name: "Bhairavi Devotional",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "bhairavi_03",
        name: "Bhairavi Film Song Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "darbari_01",
        name: "Darbari Royal Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["F3", "G#3", "C4"] },
          { step: 12, notes: ["A#2", "D3", "F3"] },
        ],
      },
      {
        id: "darbari_02",
        name: "Darbari Deep Night Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "G#3", "C4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "darbari_03",
        name: "Darbari Sufi Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["F3", "G#3", "C4"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "bageshri_01",
        name: "Bageshri Love Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "bageshri_02",
        name: "Bageshri Ghazal Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "A#3", "D4"] },
          { step: 12, notes: ["A#2", "D3", "F3"] },
        ],
      },
      {
        id: "desh_01",
        name: "Desh Patriotic",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "desh_02",
        name: "Desh Folk",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "malkauns_01",
        name: "Malkauns Mystic Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D#3", "G3"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
      {
        id: "malkauns_02",
        name: "Malkauns Temple Cycle",
        chords: [
          { step: 0, notes: ["C3", "G3", "A#3"] },
          { step: 4, notes: ["D#3", "G3", "A#3"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["A#2", "D#3", "G3"] },
        ],
      },
      {
        id: "kafi_01",
        name: "Kafi Folk",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "kafi_02",
        name: "Kafi Village Dance Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G3", "A#3", "D4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["A#2", "D3", "F3"] },
        ],
      },
      {
        id: "bhimpalasi_01",
        name: "Bhimpalasi Afternoon",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
      {
        id: "bhimpalasi_02",
        name: "Bhimpalasi Longing Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["G#3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "marwa_01",
        name: "Marwa Sunset",
        chords: [
          { step: 0, notes: ["C3", "E3", "G#3"] },
          { step: 4, notes: ["D3", "F#3", "A#3"] },
          { step: 8, notes: ["G#3", "C4", "E4"] },
          { step: 12, notes: ["D3", "F#3", "A#3"] },
        ],
      },
      {
        id: "marwa_02",
        name: "Marwa Tension",
        chords: [
          { step: 0, notes: ["C3", "E3", "G#3"] },
          { step: 4, notes: ["G#3", "C4", "E4"] },
          { step: 8, notes: ["A#2", "D3", "F#3"] },
          { step: 12, notes: ["D3", "F#3", "A#3"] },
        ],
      },
      {
        id: "todi_01",
        name: "Todi Ancient Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "F#3"] },
          { step: 4, notes: ["F3", "G#3", "C4"] },
          { step: 8, notes: ["A#2", "C#3", "F3"] },
          { step: 12, notes: ["G#3", "C4", "D#4"] },
        ],
      },
      {
        id: "todi_02",
        name: "Todi Mystical Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "F#3", "A#3"] },
          { step: 4, notes: ["F3", "G#3", "C4"] },
          { step: 8, notes: ["A#2", "D#3", "F#3"] },
          { step: 12, notes: ["G#3", "C4", "D#4"] },
        ],
      },
      {
        id: "hindustani_fusion_01",
        name: "Fusion Raga Groove Cycle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["G3", "A#3", "D4", "F4"] },
          { step: 12, notes: ["A#2", "D3", "F3"] },
        ],
      },
      {
        id: "hindustani_fusion_02",
        name: "Modern Bollywood Raga",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["A3", "C4", "E4", "G4"] },
          { step: 8, notes: ["F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
    ],
  },
  {
    category: "Arpeggio Chord Patterns",
    progressions: [
      {
        id: "arp_pop_c_g_am_f",
        name: "Arp Pop I-V-vi-IV",
        chords: [
          { step: 0, notes: ["C3"] },
          { step: 1, notes: ["E3"] },
          { step: 2, notes: ["G3"] },
          { step: 3, notes: ["E3"] },
          { step: 4, notes: ["G3"] },
          { step: 5, notes: ["B3"] },
          { step: 6, notes: ["D4"] },
          { step: 7, notes: ["B3"] },
          { step: 8, notes: ["A3"] },
          { step: 9, notes: ["C4"] },
          { step: 10, notes: ["E4"] },
          { step: 11, notes: ["C4"] },
          { step: 12, notes: ["F3"] },
          { step: 13, notes: ["A3"] },
          { step: 14, notes: ["C4"] },
          { step: 15, notes: ["G3"] },
        ],
      },
      {
        id: "arp_jazz_251",
        name: "Arp Jazz ii-V-I Turnaround",
        chords: [
          { step: 0, notes: ["D3"] },
          { step: 1, notes: ["F3"] },
          { step: 2, notes: ["A3"] },
          { step: 3, notes: ["C4"] },
          { step: 4, notes: ["G3"] },
          { step: 5, notes: ["B3"] },
          { step: 6, notes: ["D4"] },
          { step: 7, notes: ["F4"] },
          { step: 8, notes: ["C3"] },
          { step: 9, notes: ["E3"] },
          { step: 10, notes: ["G3"] },
          { step: 11, notes: ["B3"] },
          { step: 12, notes: ["A3"] },
          { step: 13, notes: ["C#4"] },
          { step: 14, notes: ["E4"] },
          { step: 15, notes: ["G4"] },
        ],
      },
      {
        id: "arp_blues_c7",
        name: "Arp Blues C7-F7-G7 Turnaround",
        chords: [
          { step: 0, notes: ["C3"] },
          { step: 1, notes: ["E3"] },
          { step: 2, notes: ["G3"] },
          { step: 3, notes: ["A#3"] },
          { step: 4, notes: ["F3"] },
          { step: 5, notes: ["A3"] },
          { step: 6, notes: ["C4"] },
          { step: 7, notes: ["D#4"] },
          { step: 8, notes: ["G3"] },
          { step: 9, notes: ["B3"] },
          { step: 10, notes: ["D4"] },
          { step: 11, notes: ["F4"] },
          { step: 12, notes: ["D3"] },
          { step: 13, notes: ["F#3"] },
          { step: 14, notes: ["A3"] },
          { step: 15, notes: ["C4"] },
        ],
      },
    ],
  },
  {
    category: "Mozart Classical",
    progressions: [
      {
        id: "mozart_cadence_01",
        name: "Classical Cadence Loop",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["D3", "F#3", "A3"] },
        ],
      },
      {
        id: "mozart_cadence_02",
        name: "Classical Half Cadence",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "mozart_alberti_01",
        name: "Alberti Bass Theme",
        chords: [
          { step: 0, notes: ["C3", "G3", "E3"] },
          { step: 4, notes: ["G2", "D3", "B3"] },
          { step: 8, notes: ["A2", "E3", "C4"] },
          { step: 12, notes: ["F2", "C3", "A3"] },
        ],
      },
      {
        id: "mozart_alberti_02",
        name: "Alberti Sonata Loop",
        chords: [
          { step: 0, notes: ["C3", "G3", "E3", "G3"] },
          { step: 4, notes: ["F3", "C4", "A3", "C4"] },
          { step: 8, notes: ["G3", "D4", "B3", "D4"] },
          { step: 12, notes: ["D3", "A3", "F#3", "A3"] },
        ],
      },
      {
        id: "mozart_sonata_01",
        name: "Sonata Exposition",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "mozart_sonata_02",
        name: "Sonata Development Loop",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["D3", "F3", "A3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["E3", "G#3", "B3"] },
        ],
      },
      {
        id: "mozart_minuet_01",
        name: "Royal Minuet",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "mozart_minuet_02",
        name: "Court Dance",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "mozart_modulation_01",
        name: "Dominant Modulation",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["D3", "F#3", "A3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F#4"] },
        ],
      },
      {
        id: "mozart_modulation_02",
        name: "Circle Of Fifths",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C#4", "E4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
    ],
  },
  {
    category: "Beethoven",
    progressions: [
      {
        id: "beethoven_moonlight_01",
        name: "Moonlight Sonata",
        chords: [
          { step: 0, notes: ["C#3", "E3", "G#3"] },
          { step: 4, notes: ["A2", "C#3", "E3"] },
          { step: 8, notes: ["E3", "G#3", "B3"] },
          { step: 12, notes: ["B2", "D#3", "F#3"] },
        ],
      },
      {
        id: "beethoven_moonlight_02",
        name: "Moonlight Dark",
        chords: [
          { step: 0, notes: ["C#3", "E3", "G#3", "B3"] },
          { step: 4, notes: ["A2", "C#3", "E3", "G#3"] },
          { step: 8, notes: ["F#3", "A3", "C#4"] },
          { step: 12, notes: ["G#3", "B3", "D#4"] },
        ],
      },
      {
        id: "beethoven_pathetique_01",
        name: "Pathetique Grave",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "beethoven_pathetique_02",
        name: "Pathetique Drama",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "beethoven_heroic_01",
        name: "Eroica Heroic",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "beethoven_heroic_02",
        name: "Victory March",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["F3", "A3", "C4"] },
        ],
      },
      {
        id: "beethoven_fifth_01",
        name: "Fifth Symphony Fate",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G3", "A#3", "D4"] },
          { step: 8, notes: ["C3", "D#3", "G3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "beethoven_fifth_02",
        name: "Fate Knocks Loop",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["G3", "A#3", "D4"] },
          { step: 12, notes: ["F3", "G#3", "C4"] },
        ],
      },
      {
        id: "beethoven_late_01",
        name: "Late Beethoven Chromatic",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["C#3", "F3", "G#3", "C4"] },
          { step: 8, notes: ["D3", "F#3", "A3", "C#4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F#4"] },
        ],
      },
      {
        id: "beethoven_late_02",
        name: "Late Quartet",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["A#2", "D3", "F#3", "A3"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
    ],
  },
  {
    category: "Classical Pattern Library",
    progressions: [
      {
        id: "alberti_c_major_01",
        name: "Alberti Bass C Major Loop",
        chords: [
          { step: 0, notes: ["C3"] },
          { step: 1, notes: ["G3"] },
          { step: 2, notes: ["E3"] },
          { step: 3, notes: ["G3"] },
          { step: 4, notes: ["F3"] },
          { step: 5, notes: ["C4"] },
          { step: 6, notes: ["A3"] },
          { step: 7, notes: ["C4"] },
          { step: 8, notes: ["G3"] },
          { step: 9, notes: ["D4"] },
          { step: 10, notes: ["B3"] },
          { step: 11, notes: ["D4"] },
          { step: 12, notes: ["D3"] },
          { step: 13, notes: ["A3"] },
          { step: 14, notes: ["F#3"] },
          { step: 15, notes: ["A3"] },
        ],
      },
      {
        id: "alberti_minor_01",
        name: "Alberti Bass Minor Loop",
        chords: [
          { step: 0, notes: ["A2"] },
          { step: 1, notes: ["E3"] },
          { step: 2, notes: ["C3"] },
          { step: 3, notes: ["E3"] },
          { step: 4, notes: ["D3"] },
          { step: 5, notes: ["A3"] },
          { step: 6, notes: ["F3"] },
          { step: 7, notes: ["A3"] },
          { step: 8, notes: ["E3"] },
          { step: 9, notes: ["B3"] },
          { step: 10, notes: ["G#3"] },
          { step: 11, notes: ["B3"] },
          { step: 12, notes: ["B2"] },
          { step: 13, notes: ["F3"] },
          { step: 14, notes: ["D3"] },
          { step: 15, notes: ["F3"] },
        ],
      },
      {
        id: "mozart_arp_01",
        name: "Mozart Bright Arpeggio",
        chords: [
          { step: 0, notes: ["C3"] },
          { step: 1, notes: ["E3"] },
          { step: 2, notes: ["G3"] },
          { step: 3, notes: ["C4"] },
          { step: 4, notes: ["G3"] },
          { step: 5, notes: ["B3"] },
          { step: 6, notes: ["D4"] },
          { step: 7, notes: ["G4"] },
          { step: 8, notes: ["A3"] },
          { step: 9, notes: ["C4"] },
          { step: 10, notes: ["E4"] },
          { step: 11, notes: ["A4"] },
          { step: 12, notes: ["F3"] },
          { step: 13, notes: ["A3"] },
          { step: 14, notes: ["C4"] },
          { step: 15, notes: ["G3"] },
        ],
      },
      {
        id: "classical_sequence_01",
        name: "Classical Descending Sequence",
        chords: [
          { step: 0, notes: ["C4"] },
          { step: 1, notes: ["B3"] },
          { step: 2, notes: ["A3"] },
          { step: 3, notes: ["G3"] },
          { step: 4, notes: ["F3"] },
          { step: 5, notes: ["E3"] },
          { step: 6, notes: ["D3"] },
          { step: 7, notes: ["C3"] },
          { step: 8, notes: ["D3"] },
          { step: 9, notes: ["E3"] },
          { step: 10, notes: ["F3"] },
          { step: 11, notes: ["G3"] },
          { step: 12, notes: ["A3"] },
          { step: 13, notes: ["G3"] },
          { step: 14, notes: ["F3"] },
          { step: 15, notes: ["E3"] },
        ],
      },
      {
        id: "beethoven_ostinato_01",
        name: "Beethoven Fate Ostinato",
        chords: [
          { step: 0, notes: ["G3"] },
          { step: 1, notes: ["G3"] },
          { step: 2, notes: ["G3"] },
          { step: 3, notes: ["D#3"] },
          { step: 4, notes: ["F3"] },
          { step: 5, notes: ["F3"] },
          { step: 6, notes: ["F3"] },
          { step: 7, notes: ["D3"] },
          { step: 8, notes: ["G3"] },
          { step: 9, notes: ["G3"] },
          { step: 10, notes: ["G3"] },
          { step: 11, notes: ["D#3"] },
          { step: 12, notes: ["A#2", "D3", "F3"] },
          { step: 14, notes: ["G2", "D3", "G3"] },
        ],
      },
      {
        id: "beethoven_ostinato_02",
        name: "Beethoven Storm Ostinato",
        chords: [
          { step: 0, notes: ["C3", "G3"] },
          { step: 1, notes: ["C3"] },
          { step: 2, notes: ["G3"] },
          { step: 3, notes: ["C3"] },
          { step: 4, notes: ["G#2", "D#3"] },
          { step: 5, notes: ["G#2"] },
          { step: 6, notes: ["D#3"] },
          { step: 7, notes: ["G#2"] },
          { step: 8, notes: ["A#2", "F3"] },
          { step: 9, notes: ["A#2"] },
          { step: 10, notes: ["F3"] },
          { step: 11, notes: ["A#2"] },
          { step: 12, notes: ["G2", "D3"] },
          { step: 13, notes: ["G2"] },
          { step: 14, notes: ["D3"] },
          { step: 15, notes: ["G2"] },
        ],
      },
      {
        id: "counterpoint_01",
        name: "Simple Counterpoint Motion Loop",
        chords: [
          { step: 0, notes: ["C3", "E4"] },
          { step: 1, notes: ["D3", "F4"] },
          { step: 2, notes: ["E3", "G4"] },
          { step: 3, notes: ["F3", "A4"] },
          { step: 4, notes: ["G3", "B4"] },
          { step: 5, notes: ["A3", "C5"] },
          { step: 6, notes: ["G3", "B4"] },
          { step: 7, notes: ["F3", "A4"] },
          { step: 8, notes: ["E3", "G4"] },
          { step: 9, notes: ["D3", "F4"] },
          { step: 10, notes: ["C3", "E4"] },
          { step: 11, notes: ["G2", "D4"] },
          { step: 12, notes: ["A2", "C4"] },
          { step: 14, notes: ["G2", "D4"] },
        ],
      },
      {
        id: "counterpoint_02",
        name: "Contrary Motion Counterpoint Loop",
        chords: [
          { step: 0, notes: ["C3", "C5"] },
          { step: 1, notes: ["D3", "B4"] },
          { step: 2, notes: ["E3", "A4"] },
          { step: 3, notes: ["F3", "G4"] },
          { step: 4, notes: ["G3", "F4"] },
          { step: 5, notes: ["A3", "E4"] },
          { step: 6, notes: ["B3", "D4"] },
          { step: 7, notes: ["C4", "C4"] },
          { step: 8, notes: ["B3", "D4"] },
          { step: 9, notes: ["A3", "E4"] },
          { step: 10, notes: ["G3", "F4"] },
          { step: 11, notes: ["F3", "G4"] },
          { step: 12, notes: ["E3", "A4"] },
          { step: 13, notes: ["D3", "B4"] },
          { step: 14, notes: ["G2", "D4"] },
        ],
      },
    ],
  },
  {
    category: "Romantic Era",
    progressions: [
      {
        id: "chopin_01",
        name: "Chopin Nocturne",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["D3", "F3", "A3", "C4"] },
          { step: 8, notes: ["F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4"] },
        ],
      },
      {
        id: "chopin_02",
        name: "Chopin Waltz",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "chopin_03",
        name: "Chopin Ballade",
        chords: [
          { step: 0, notes: ["G3", "A#3", "D4"] },
          { step: 4, notes: ["D#3", "G3", "A#3"] },
          { step: 8, notes: ["C3", "D#3", "G3"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] },
        ],
      },
      {
        id: "chopin_04",
        name: "Chopin Prelude",
        chords: [
          { step: 0, notes: ["E3", "G3", "B3"] },
          { step: 4, notes: ["C3", "E3", "G3"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["B3", "D#4", "F#4"] },
        ],
      },
      {
        id: "chopin_05",
        name: "Chopin Funeral",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["E3", "G#3", "B3"] },
        ],
      },
      {
        id: "liszt_01",
        name: "Liszt Thunder",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["G#3", "C4", "D#4", "G4"] },
          { step: 8, notes: ["D#3", "G3", "A#3", "D4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "liszt_02",
        name: "Liszt Hungarian",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["E3", "G#3", "B3"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4"] },
        ],
      },
      {
        id: "liszt_03",
        name: "Liszt Transcendent",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["D#3", "G3", "A#3", "C#4"] },
          { step: 8, notes: ["G#3", "C4", "D#4", "G4"] },
          { step: 12, notes: ["B3", "D#4", "F#4", "A4"] },
        ],
      },
      {
        id: "liszt_04",
        name: "Liszt Dream",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["A3", "C4", "E4", "G4"] },
          { step: 8, notes: ["F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "liszt_05",
        name: "Liszt Devil",
        chords: [
          { step: 0, notes: ["C3", "D#3", "F#3", "A3"] },
          { step: 4, notes: ["F#3", "A3", "C4", "D#4"] },
          { step: 8, notes: ["A3", "C4", "D#4", "F#4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "tchaikovsky_01",
        name: "Tchaikovsky Ballet",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["E3", "G3", "B3"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["F3", "A3", "C4"] },
        ],
      },
      {
        id: "tchaikovsky_02",
        name: "Tchaikovsky Swan",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["C3", "E3", "G3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "tchaikovsky_03",
        name: "Tchaikovsky Romeo Loop",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["A3", "C#4", "E4"] },
        ],
      },
      {
        id: "tchaikovsky_04",
        name: "Tchaikovsky Waltz Loop",
        chords: [
          { step: 0, notes: ["G3", "B3", "D4"] },
          { step: 4, notes: ["D3", "F#3", "A3"] },
          { step: 8, notes: ["E3", "G3", "B3"] },
          { step: 12, notes: ["C3", "E3", "G3"] },
        ],
      },
      {
        id: "tchaikovsky_05",
        name: "Tchaikovsky Tragic",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["D#3", "G3", "A#3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "brahms_01",
        name: "Brahms Lullaby",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["F3", "A3", "C4", "E4"] },
        ],
      },
      {
        id: "brahms_02",
        name: "Brahms Intermezzo",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4"] },
        ],
      },
      {
        id: "brahms_03",
        name: "Brahms Autumn",
        chords: [
          { step: 0, notes: ["E3", "G3", "B3"] },
          { step: 4, notes: ["C3", "E3", "G3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["D3", "F#3", "A3"] },
        ],
      },
      {
        id: "brahms_04",
        name: "Brahms Noble",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "brahms_05",
        name: "Brahms Dark Waltz",
        chords: [
          { step: 0, notes: ["G3", "A#3", "D4"] },
          { step: 4, notes: ["D#3", "G3", "A#3"] },
          { step: 8, notes: ["C3", "D#3", "G3"] },
          { step: 12, notes: ["D3", "F#3", "A3"] },
        ],
      },
      {
        id: "rachmaninoff_01",
        name: "Rachmaninoff Epic",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4", "B4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "rachmaninoff_02",
        name: "Rachmaninoff Bells",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["G#3", "C4", "D#4", "G4"] },
          { step: 8, notes: ["F3", "G#3", "C4", "D#4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "rachmaninoff_03",
        name: "Rachmaninoff Piano Concerto",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3", "A#3"] },
          { step: 4, notes: ["A#2", "D3", "F3", "G#3"] },
          { step: 8, notes: ["G#3", "C4", "D#4", "G4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "rachmaninoff_04",
        name: "Rachmaninoff Melancholy",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] },
          { step: 4, notes: ["A#2", "D3", "F3", "A3"] },
          { step: 8, notes: ["F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["C3", "E3", "G3", "A#3"] },
        ],
      },
      {
        id: "rachmaninoff_05",
        name: "Rachmaninoff Finale",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] },
        ],
      },
      {
        id: "debussy_01",
        name: "Debussy Dream Loop",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["D3", "F#3", "A3", "C#4", "E4"] },
          { step: 8, notes: ["E3", "G#3", "B3", "D#4", "F#4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F#4"] },
        ],
      },
      {
        id: "debussy_02",
        name: "Debussy Whole Tone Loop",
        chords: [
          { step: 0, notes: ["C3", "E3", "F#3", "A#3"] },
          { step: 4, notes: ["D3", "F#3", "G#3", "C4"] },
          { step: 8, notes: ["E3", "G#3", "A#3", "D4"] },
          { step: 12, notes: ["G#3", "C4", "D4", "F#4"] },
        ],
      },
      {
        id: "debussy_03",
        name: "Debussy Parallel Majors",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["D3", "F#3", "A3"] },
          { step: 8, notes: ["E3", "G#3", "B3"] },
          { step: 12, notes: ["F#3", "A#3", "C#4"] },
        ],
      },
      {
        id: "debussy_04",
        name: "Debussy Lydian Mist Loop",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["D3", "F#3", "A3", "C4"] },
          { step: 8, notes: ["F#3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F#4"] },
        ],
      },
      {
        id: "debussy_05",
        name: "Debussy Impressionist",
        chords: [
          { step: 0, notes: ["C3", "G3", "D4"] },
          { step: 4, notes: ["D3", "A3", "E4"] },
          { step: 8, notes: ["E3", "B3", "F#4"] },
          { step: 12, notes: ["G3", "D4", "A4"] },
        ],
      },
    ],
  },
  {
    category: "Brazilian & Latin",
    progressions: [
      {
        id: "jobim_01",
        name: "Jobim Wave",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["A3", "C#4", "E4", "G4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4", "E4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
        ],
      },
      {
        id: "jobim_02",
        name: "Girl From Ipanema",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C4", "E4", "G4"] },
        ],
      },
      {
        id: "jobim_03",
        name: "Jobim Sunset",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "jobim_04",
        name: "Rio Nights Loop",
        chords: [
          { step: 0, notes: ["A3", "C#4", "E4", "G4"] },
          { step: 4, notes: ["D3", "F#3", "A3", "C4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4"] },
        ],
      },
      {
        id: "jobim_05",
        name: "Brazil Romance",
        chords: [
          { step: 0, notes: ["E3", "G#3", "B3", "D#4"] },
          { step: 4, notes: ["C#3", "F3", "G#3", "B3"] },
          { step: 8, notes: ["F#3", "A3", "C#4", "E4"] },
          { step: 12, notes: ["B2", "D#3", "F#3", "A3"] },
        ],
      },
      {
        id: "bossa_01",
        name: "Classic Bossa",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4", "A4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "bossa_02",
        name: "Smooth Bossa",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["D3", "F3", "A3", "C4"] },
        ],
      },
      {
        id: "bossa_03",
        name: "Beach Cafe",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["E3", "G3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C4", "E4", "G4"] },
        ],
      },
      {
        id: "bossa_04",
        name: "Rainy Bossa Loop",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["D3", "F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F4"] },
          { step: 12, notes: ["E3", "G#3", "B3", "D4"] },
        ],
      },
      {
        id: "bossa_05",
        name: "Night Lounge",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A#3"] },
          { step: 4, notes: ["F3", "A3", "C4", "D#4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "samba_01",
        name: "Rio Carnival Loop",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "A3"] },
          { step: 4, notes: ["D3", "F3", "A3", "C4"] },
          { step: 8, notes: ["G3", "B3", "D4", "F4"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "samba_02",
        name: "Street Samba Loop",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["E3", "G3", "B3"] },
        ],
      },
      {
        id: "samba_03",
        name: "Fast Samba Loop",
        chords: [
          { step: 0, notes: ["A3", "C#4", "E4"] },
          { step: 4, notes: ["D3", "F#3", "A3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["E3", "G#3", "B3"] },
        ],
      },
      {
        id: "samba_04",
        name: "Festival Samba",
        chords: [
          { step: 0, notes: ["G3", "B3", "D4"] },
          { step: 4, notes: ["E3", "G3", "B3"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["D3", "F#3", "A3"] },
        ],
      },
      {
        id: "samba_05",
        name: "Samba Groove",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "mpb_01",
        name: "Modern MPB",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["A3", "C#4", "E4", "G4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "mpb_02",
        name: "Brazilian Pop",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "mpb_03",
        name: "Acoustic MPB",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "mpb_04",
        name: "MPB Soul",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["E3", "G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["D3", "F3", "A3", "C4"] },
        ],
      },
      {
        id: "mpb_05",
        name: "MPB Dream",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
    ],
  },
  {
    category: "K-Pop & J-Pop",
    progressions: [
      {
        id: "bts_01",
        name: "BTS Emotional",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4", "G4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "bts_02",
        name: "BTS Anthem",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["F3", "A3", "C4"] },
        ],
      },
      {
        id: "bts_03",
        name: "BTS Stadium",
        chords: [
          { step: 0, notes: ["D3", "F#3", "A3"] },
          { step: 4, notes: ["A3", "C#4", "E4"] },
          { step: 8, notes: ["B3", "D4", "F#4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "exo_01",
        name: "EXO RnB",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["A3", "C#4", "E4", "G4"] },
          { step: 8, notes: ["D3", "F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4", "A4"] },
        ],
      },
      {
        id: "exo_02",
        name: "EXO Smooth",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["E3", "G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["D3", "F3", "A3", "C4"] },
        ],
      },
      {
        id: "twice_01",
        name: "TWICE Bright",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "twice_02",
        name: "TWICE Summer",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4"] },
          { step: 4, notes: ["C3", "E3", "G3"] },
          { step: 8, notes: ["G3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C4", "E4"] },
        ],
      },
      {
        id: "newjeans_01",
        name: "NewJeans Minimal",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["F3", "A3", "C4", "E4"] },
        ],
      },
      {
        id: "newjeans_02",
        name: "NewJeans Dream",
        chords: [
          { step: 0, notes: ["C3", "G3", "D4"] },
          { step: 4, notes: ["A3", "E4", "B4"] },
          { step: 8, notes: ["F3", "C4", "G4"] },
          { step: 12, notes: ["G3", "D4", "A4"] },
        ],
      },
      {
        id: "blackpink_01",
        name: "Blackpink Drop",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["C3", "E3", "G3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "blackpink_02",
        name: "Blackpink Dark Pop",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "anime_hero_01",
        name: "Anime Hero Theme",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4"] },
          { step: 12, notes: ["F3", "A3", "C4"] },
        ],
      },
      {
        id: "anime_hero_02",
        name: "Shonen Victory",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["E3", "G3", "B3"] },
          { step: 12, notes: ["A3", "C4", "E4"] },
        ],
      },
      {
        id: "anime_sad_01",
        name: "Anime Farewell",
        chords: [
          { step: 0, notes: ["A3", "C4", "E4"] },
          { step: 4, notes: ["F3", "A3", "C4"] },
          { step: 8, notes: ["C3", "E3", "G3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "anime_sad_02",
        name: "Rain Scene Loop",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3"] },
          { step: 4, notes: ["A#2", "D3", "F3"] },
          { step: 8, notes: ["F3", "A3", "C4"] },
          { step: 12, notes: ["A3", "C#4", "E4"] },
        ],
      },
      {
        id: "citypop_01",
        name: "City Pop Cruise",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3"] },
          { step: 4, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 8, notes: ["A3", "C4", "E4", "G4"] },
          { step: 12, notes: ["D3", "F#3", "A3", "C4"] },
        ],
      },
      {
        id: "citypop_02",
        name: "Night Drive Tokyo",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4", "E4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["E3", "G#3", "B3", "D4"] },
          { step: 12, notes: ["A3", "C4", "E4", "G4"] },
        ],
      },
      {
        id: "jrpg_01",
        name: "JRPG Adventure",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["A3", "C4", "E4"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4"] },
        ],
      },
      {
        id: "jrpg_02",
        name: "JRPG Final Battle",
        chords: [
          { step: 0, notes: ["C3", "D#3", "G3"] },
          { step: 4, notes: ["G#3", "C4", "D#4"] },
          { step: 8, notes: ["A#2", "D3", "F3"] },
          { step: 12, notes: ["G3", "A#3", "D4"] },
        ],
      },
      {
        id: "yokokanno_01",
        name: "Yoko Kanno Jazz Anime",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3", "B3", "D4"] },
          { step: 4, notes: ["F3", "A3", "C4", "E4"] },
          { step: 8, notes: ["A#2", "D3", "F3", "A3"] },
          { step: 12, notes: ["G3", "B3", "D4", "F4"] },
        ],
      },
      {
        id: "yokokanno_02",
        name: "Space Cowboy",
        chords: [
          { step: 0, notes: ["D3", "F3", "A3", "C4"] },
          { step: 4, notes: ["G3", "B3", "D4", "F4"] },
          { step: 8, notes: ["C3", "E3", "G3", "B3"] },
          { step: 12, notes: ["A3", "C#4", "E4", "G4"] },
        ],
      },
      {
        id: "hisaishi_01",
        name: "Hisaishi Wonder",
        chords: [
          { step: 0, notes: ["C3", "E3", "G3"] },
          { step: 4, notes: ["G3", "B3", "D4"] },
          { step: 8, notes: ["D3", "F#3", "A3"] },
          { step: 12, notes: ["A3", "C#4", "E4"] },
        ],
      },
      {
        id: "hisaishi_02",
        name: "Spirited Journey",
        chords: [
          { step: 0, notes: ["F3", "A3", "C4"] },
          { step: 4, notes: ["C3", "E3", "G3"] },
          { step: 8, notes: ["D3", "F3", "A3"] },
          { step: 12, notes: ["A3", "C4", "E4"] },
        ],
      },
    ],
  },
];

export const findChordProgressionById = (progressionId) => {
  for (const group of chordProgressionGroups) {
    const found = group.progressions.find((p) => p.id === progressionId);
    if (found) return found;
  }
  return null;
};
